/**
 * AUTO-GENERATED TypeScript types from backend Pydantic models
 * 
 * DO NOT EDIT THIS FILE MANUALLY
 * 
 * Generated by: backend/scripts/generate_typescript_types.py
 * 
 * Source: backend/common/models.py
 * Source: backend/common/websocket_types.py
 * Source: backend/common/enums.py
 * 
 * To regenerate: npm run types:generate
 */

// ============================================================================
// Enums
// ============================================================================

export const InvestigationState = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
} as const;

export type InvestigationStateType = typeof InvestigationState[keyof typeof InvestigationState];

export const SwitchMode = {
  OFF: 'off',
  GROUPS: 'groups',
  EVERYONE: 'everyone',
} as const;

export type SwitchModeType = typeof SwitchMode[keyof typeof SwitchMode];

export const AgentStatus = {
  IDLE: 'idle',
  THINKING: 'thinking',
  COMPLETED: 'completed',
  ERROR: 'error',
} as const;

export type AgentStatusType = typeof AgentStatus[keyof typeof AgentStatus];

export const MessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant',
} as const;

export type MessageRoleType = typeof MessageRole[keyof typeof MessageRole];

export const MessageType = {
  TEXT: 'text',
  TOOL_USE: 'tool_use',
  TOOL_RESULT: 'tool_result',
} as const;

export type MessageTypeType = typeof MessageType[keyof typeof MessageType];

export const WebSocketEventType = {
  CHUNK: 'chunk',
  REASONING: 'reasoning',
  OBSERVABILITY: 'observability',
  COMPLETE: 'complete',
  ERROR: 'error',
  FINDING_ADDED: 'finding_added',
  BLOCK: 'block',
} as const;

export type WebSocketEventTypeType = typeof WebSocketEventType[keyof typeof WebSocketEventType];

export const ErrorCode = {
  CONNECTION_NOT_FOUND: 'CONNECTION_NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  AGENTCORE_ERROR: 'AGENTCORE_ERROR',
  PROCESSING_ERROR: 'PROCESSING_ERROR',
  AGENT_BUSY: 'AGENT_BUSY',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  EMPTY_MESSAGE: 'EMPTY_MESSAGE',
  INVESTIGATION_NOT_FOUND: 'INVESTIGATION_NOT_FOUND',
  CUSTOMER_DELETED: 'CUSTOMER_DELETED',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  INVALID_JSON: 'INVALID_JSON',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const;

export type ErrorCodeType = typeof ErrorCode[keyof typeof ErrorCode];

export const PromptAccountScope = {
  NONE: 'none',
  OPERATIONS: 'operations',
  CUSTOMER: 'customer',
  BOTH: 'both',
} as const;

export type PromptAccountScopeType = typeof PromptAccountScope[keyof typeof PromptAccountScope];

export const PromptOwner = {
  CUSTOMER: 'customer',
  GLOBAL: 'global',
} as const;

export type PromptOwnerType = typeof PromptOwner[keyof typeof PromptOwner];

export const TemplateOwner = {
  CUSTOMER: 'customer',
  GLOBAL: 'global',
} as const;

export type TemplateOwnerType = typeof TemplateOwner[keyof typeof TemplateOwner];

export const PlaybookOwner = PromptOwner;
export type PlaybookOwnerType = PromptOwnerType;

export const PromptType = {
  PLAYBOOK: 'playbook',
  SYSTEM_PROMPT: 'system_prompt',
  AUTOMATION_PROMPT: 'automation_prompt',
  SKILL: 'skill',
  LEARNED_SKILL: 'learned_skill',
  ENRICHMENT: 'enrichment',
  REPORT: 'report',
} as const;

export type PromptTypeType = typeof PromptType[keyof typeof PromptType];

export const SkillApplicability = {
  INTERACTIVE: 'interactive',
  BATCH: 'batch',
  BOTH: 'both',
} as const;

export type SkillApplicabilityType = typeof SkillApplicability[keyof typeof SkillApplicability];

export const InvocationShape = {
  INTERACTIVE: 'interactive',
  BATCH: 'batch',
  SUB_AGENT: 'sub_agent',
} as const;

export type InvocationShapeType = typeof InvocationShape[keyof typeof InvocationShape];

export const AgentLifecycle = {
  ACTIVE: 'active',
  RETIRED: 'retired',
} as const;

export type AgentLifecycleType = typeof AgentLifecycle[keyof typeof AgentLifecycle];

export const ThinkingEffort = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  XHIGH: 'xhigh',
  MAX: 'max',
} as const;

export type ThinkingEffortType = typeof ThinkingEffort[keyof typeof ThinkingEffort];

export const ModelUse = {
  EVENT_ENRICHMENT: 'event_enrichment',
  EVENT_FORMATTING: 'event_formatting',
  MAPPING_SUGGESTION: 'mapping_suggestion',
  QUEST_MASTER: 'quest_master',
} as const;

export type ModelUseType = typeof ModelUse[keyof typeof ModelUse];

export const TargetType = {
  SNS: 'sns',
  EMAIL: 'email',
  TICKET: 'ticket',
  OPSITEM: 'opsitem',
  AUTOMATION: 'automation',
} as const;

export type TargetTypeType = typeof TargetType[keyof typeof TargetType];

export const RuleDeploymentLocation = {
  OPSPILOT: 'opspilot',
  OPERATIONS: 'operations',
} as const;

export type RuleDeploymentLocationType = typeof RuleDeploymentLocation[keyof typeof RuleDeploymentLocation];

export const RuleSyncStatus = {
  PENDING: 'pending',
  SYNCED: 'synced',
  FAILED: 'failed',
  DELETING: 'deleting',
} as const;

export type RuleSyncStatusType = typeof RuleSyncStatus[keyof typeof RuleSyncStatus];

export const OpsItemStrategy = {
  TRACK: 'track',
  ALWAYS_NEW: 'always_new',
  FINGERPRINT: 'fingerprint',
} as const;

export type OpsItemStrategyType = typeof OpsItemStrategy[keyof typeof OpsItemStrategy];

export const RuleType = {
  ALERT: 'alert',
  AUTOMATION: 'automation',
} as const;

export type RuleTypeType = typeof RuleType[keyof typeof RuleType];

export const AutomationContentType = {
  TEXT: 'text/plain',
  MARKDOWN: 'text/markdown',
  HTML: 'text/html',
} as const;

export type AutomationContentTypeType = typeof AutomationContentType[keyof typeof AutomationContentType];

export const DriftStatus = {
  IN_SYNC: 'in-sync',
  OUTDATED: 'outdated',
  MISSING: 'missing',
  ORPHANED: 'orphaned',
  PENDING_TERMINATION: 'pending-termination',
  PENDING_DEREGISTER: 'pending-deregister',
  FAILED: 'failed',
  UNKNOWN: 'unknown',
} as const;

export type DriftStatusType = typeof DriftStatus[keyof typeof DriftStatus];

export const DriftReason = {
  USER_UPDATED_DESIRED: 'user-updated-desired',
  MANUAL_CHANGE_IN_AWS: 'manual-change-in-aws',
  INITIAL_SUBSCRIPTION: 'initial-subscription',
  ACKNOWLEDGED_ERROR: 'acknowledged-error',
  PENDING_USER_APPROVAL: 'pending-user-approval',
  MISSING_REQUIRED_PARAMETERS: 'missing-required-parameters',
  RECONCILIATION_FAILED: 'reconciliation-failed',
} as const;

export type DriftReasonType = typeof DriftReason[keyof typeof DriftReason];
export const DesiredStateSyncStatus = {
  PENDING: 'pending',
  SYNCED: 'synced',
  FAILED: 'failed',
} as const;

export type DesiredStateSyncStatusType = typeof DesiredStateSyncStatus[keyof typeof DesiredStateSyncStatus];
export const ReconcileBlockedReason = {
  DRIFT_NOT_ACTIONABLE: 'drift_not_actionable',
  PRODUCT_INACTIVE: 'product_inactive',
  STALE_HEARTBEAT: 'stale_heartbeat',
  BLOCKED_ACTUAL_STATUS: 'blocked_actual_status',
  APPROVAL_REQUIRED: 'approval_required',
  SHARE_NOT_READY: 'share_not_ready',
  ACTION_PENDING: 'action_pending',
  BINDINGS_INCOMPLETE: 'bindings_incomplete',
  DEP_ORDER_UNRESOLVED: 'dep_order_unresolved',
  DEP_PRODUCT_NOT_FOUND: 'dep_product_not_found',
  DEP_NOT_IN_SYNC: 'dep_not_in_sync',
  DEP_OUTPUT_UNAVAILABLE: 'dep_output_unavailable',
} as const;

export type ReconcileBlockedReasonType = typeof ReconcileBlockedReason[keyof typeof ReconcileBlockedReason];

export const TriggerKind = {
  SCHEDULED: 'scheduled',
  EVENT_DRIVEN: 'event_driven',
  MANUAL: 'manual',
} as const;

export type TriggerKindType = typeof TriggerKind[keyof typeof TriggerKind];

export const PhaseOutcome = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  RUNNING: 'running',
  NOT_REACHED: 'not_reached',
  UNKNOWN: 'unknown',
} as const;

export type PhaseOutcomeType = typeof PhaseOutcome[keyof typeof PhaseOutcome];

export const VerifyOutcome = {
  CONVERGED: 'CONVERGED',
  SETTLING: 'SETTLING',
  DRIFTED: 'DRIFTED',
} as const;

export type VerifyOutcomeType = typeof VerifyOutcome[keyof typeof VerifyOutcome];

export const DeploymentStatus = {
  DEPLOYED: 'deployed',
  TERMINATED: 'terminated',
  UNSUBSCRIBED: 'unsubscribed',
} as const;

export type DeploymentStatusType = typeof DeploymentStatus[keyof typeof DeploymentStatus];

export const ServiceComponentStatus = {
  ACTIVE: 'active',
  DEPRECATED: 'deprecated',
  ARCHIVED: 'archived',
} as const;

export type ServiceComponentStatusType = typeof ServiceComponentStatus[keyof typeof ServiceComponentStatus];

export const DeploymentAction = {
  LAUNCH: 'launch',
  UPDATE: 'update',
  TERMINATE: 'terminate',
  NO_OP: 'no-op',
  SKIP: 'skip',
} as const;

export type DeploymentActionType = typeof DeploymentAction[keyof typeof DeploymentAction];

export const DeploymentHistoryEventType = {
  HEARTBEAT: 'HEARTBEAT',
  DESIRED_STATE_CHANGED: 'DESIRED_STATE_CHANGED',
  LAUNCH_STARTED: 'LAUNCH_STARTED',
  LAUNCH_SUCCEEDED: 'LAUNCH_SUCCEEDED',
  LAUNCH_FAILED: 'LAUNCH_FAILED',
  UPDATE_STARTED: 'UPDATE_STARTED',
  UPDATE_SUCCEEDED: 'UPDATE_SUCCEEDED',
  UPDATE_FAILED: 'UPDATE_FAILED',
  TERMINATE_STARTED: 'TERMINATE_STARTED',
  TERMINATE_SUCCEEDED: 'TERMINATE_SUCCEEDED',
  TERMINATE_FAILED: 'TERMINATE_FAILED',
  DRIFT_DETECTED: 'DRIFT_DETECTED',
  ERROR_REPORTED: 'ERROR_REPORTED',
  LAUNCH_BLOCKED: 'LAUNCH_BLOCKED',
  DESIRED_STATE_SYNCED: 'DESIRED_STATE_SYNCED',
} as const;

export type DeploymentHistoryEventTypeType = typeof DeploymentHistoryEventType[keyof typeof DeploymentHistoryEventType];

export const EffectiveLevel = {
  NONE: 'none',
  L1: 'l1',
  L2: 'l2',
  ADMIN: 'admin',
} as const;

export type EffectiveLevelType = typeof EffectiveLevel[keyof typeof EffectiveLevel];

export const PipelineCredentialStatus = {
  ACTIVE: 'active',
  REVOKED: 'revoked',
} as const;

export type PipelineCredentialStatusType = typeof PipelineCredentialStatus[keyof typeof PipelineCredentialStatus];

export const BaselineLayer = {
  FOUNDATION: 'FOUNDATION',
  OPTIONAL: 'OPTIONAL',
} as const;

export type BaselineLayerType = typeof BaselineLayer[keyof typeof BaselineLayer];
export const BaselineScope = {
  ACCOUNT: 'account',
  REGION: 'region',
  BILLING_REGION: 'billing_region',
} as const;

export type BaselineScopeType = typeof BaselineScope[keyof typeof BaselineScope];
export const BaselineStackStatus = {
  NOT_STARTED: 'NOT_STARTED',
  CONVERGED: 'CONVERGED',
  APPLYING: 'APPLYING',
  PENDING: 'PENDING',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
} as const;

export type BaselineStackStatusType = typeof BaselineStackStatus[keyof typeof BaselineStackStatus];

export const Priority = {
  P1: 'P1',
  P2: 'P2',
  P3: 'P3',
  P4: 'P4',
} as const;

export type PriorityType = typeof Priority[keyof typeof Priority];

export const RuleKind = {
  REACTIVE: 'REACTIVE',
  INFORMATIONAL: 'INFORMATIONAL',
} as const;

export type RuleKindType = typeof RuleKind[keyof typeof RuleKind];

export const ProvisionerKind = {
  AWS_SC: 'AWS_SC',
  AZURE_BLUEPRINT: 'AZURE_BLUEPRINT',
  GCP_DEPLOYMENT_MANAGER: 'GCP_DEPLOYMENT_MANAGER',
  TERRAFORM_CLOUD: 'TERRAFORM_CLOUD',
} as const;

export type ProvisionerKindType = typeof ProvisionerKind[keyof typeof ProvisionerKind];

export const ConfigurationStatus = {
  PROVISIONING: 'PROVISIONING',
  ACTIVE: 'ACTIVE',
  DEPRECATING: 'DEPRECATING',
  REVOKED: 'REVOKED',
} as const;

export type ConfigurationStatusType = typeof ConfigurationStatus[keyof typeof ConfigurationStatus];

export const TraceStatus = {
  CONFIRMED: 'confirmed',
  FAILED: 'failed',
  INFERRED: 'inferred',
  DEGRADED: 'degraded',
  UNMATCHED: 'unmatched',
  NO_DATA: 'no_data',
} as const;

export type TraceStatusType = typeof TraceStatus[keyof typeof TraceStatus];

export const QuestType = {
  ONBOARDING: 'onboarding',
  INVESTIGATION: 'investigation',
  IMPROVEMENT: 'improvement',
  CHALLENGE: 'challenge',
  BOSS_BATTLE: 'boss_battle',
  DAILY: 'daily',
  SPRINT: 'sprint',
  CAMPAIGN: 'campaign',
} as const;

export type QuestTypeType = typeof QuestType[keyof typeof QuestType];

export const QuestStatus = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
} as const;

export type QuestStatusType = typeof QuestStatus[keyof typeof QuestStatus];

export const TaskStatus = {
  AVAILABLE: 'available',
  CLAIMED: 'claimed',
  COMPLETED: 'completed',
  ABANDONED: 'abandoned',
  EXPIRED: 'expired',
} as const;

export type TaskStatusType = typeof TaskStatus[keyof typeof TaskStatus];

export const TaskComplexity = {
  TRIVIAL: 'trivial',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EPIC: 'epic',
} as const;

export type TaskComplexityType = typeof TaskComplexity[keyof typeof TaskComplexity];

export const TaskAgeStage = {
  FRESH: 'fresh',
  WARMING: 'warming',
  AGING: 'aging',
  CRITICAL: 'critical',
  BREACH: 'breach',
} as const;

export type TaskAgeStageType = typeof TaskAgeStage[keyof typeof TaskAgeStage];

export const AchievementType = {
  MILESTONE: 'milestone',
  COMBO: 'combo',
  STREAK: 'streak',
  QUALITY: 'quality',
  TEAM: 'team',
  SEASONAL: 'seasonal',
} as const;

export type AchievementTypeType = typeof AchievementType[keyof typeof AchievementType];

export const MasteryTrack = {
  ONBOARDING: 'onboarding',
  PROMPT_ENGINEERING: 'prompt_engineering',
  INVESTIGATION: 'investigation',
  KNOWLEDGE: 'knowledge',
  AUTOMATION: 'automation',
  CONFIGURATION: 'configuration',
} as const;

export type MasteryTrackType = typeof MasteryTrack[keyof typeof MasteryTrack];

export const QualityOutcome = {
  PERFECT: 'perfect',
  MINOR_FIX: 'minor_fix',
  REWORK: 'rework',
  FAILED: 'failed',
  PENDING: 'pending',
} as const;

export type QualityOutcomeType = typeof QualityOutcome[keyof typeof QualityOutcome];

export const ComboType = {
  SAME_SKILL: 'same_skill',
  CROSS_CUSTOMER: 'cross_customer',
  FULL_STACK: 'full_stack',
  FIRE_FIGHTER: 'fire_fighter',
  SPEED_RUN: 'speed_run',
} as const;

export type ComboTypeType = typeof ComboType[keyof typeof ComboType];

// ============================================================================
// Data Models
// ============================================================================

/**
 * AWS account scope item with metadata
 */
export interface AwsAccountScopeItem {
  /** Real AWS account ID (12-digit number) */
  aws_account_id: string;
  /** Human-readable account name for display */
  account_name: string;
  /** Primary region for this account */
  main_region?: string;
  /** All regions where customer has onboarded workloads */
  supported_regions?: string[];
}

/**
 * AWS account scope for an investigation
 */
export interface InvestigationScope {
  /** AWS accounts in investigation scope with metadata */
  accounts?: AwsAccountScopeItem[];
}

/**
 * Knowledge item attached to an investigation
 */
export interface KnowledgeItem {
  /** Investigation-internal ID for operations (e.g., 'kref-<uuid>') */
  id: string;
  /** ID of the knowledge base containing the document */
  knowledge_base_id: string;
  /** ID of the specific document in the knowledge base */
  knowledge_item_id: string;
  /** Knowledge item title */
  title: string;
  /** Brief summary of the knowledge item */
  summary: string;
  /** Priority rank (0 = highest priority) */
  rank: number;
}

/**
 * Investigation finding with severity and metadata
 */
export interface Finding {
  /** Unique finding ID */
  id: string;
  /** Concise finding title (5-10 words recommended) */
  title: string;
  /** 1-2 sentence summary for list view */
  summary: string;
  /** Detailed finding description with context */
  description: string;
  /** Priority rank (0 = most critical) */
  rank: number;
  /** Mark as irrelevant to investigation */
  irrelevant: boolean;
  /** Mark as potential root cause */
  potential_root_cause: boolean;
  /** Tags for organizing and filtering findings */
  tags: string[];
}

/**
 * Playbook reference in investigation
 */
export interface PlaybookReference {
  /** Playbook ID */
  id: string;
  /** Active version (e.g., '2', 'DRAFT') */
  version: string;
  /** Playbook owner (customer or global) */
  owner: PromptOwnerType;
  /** Playbook title (denormalized for display) */
  title: string;
  /** Whether the playbook has been executed for this investigation */
  executed?: boolean;
}

/**
 * Token accounting for one agent turn (buckets are mutually exclusive — sum them for a total)
 */
export interface TokenUsage {
  /** Model that produced this turn */
  model_id: string;
  /** Uncached input tokens (excludes cache read/write) */
  input_tokens?: number;
  /** Generated output tokens */
  output_tokens?: number;
  /** Input tokens served from the prompt cache */
  cache_read_tokens?: number;
  /** Input tokens written to the prompt cache */
  cache_write_tokens?: number;
  /** Uncached input tokens spent by sub-agents */
  subagent_input_tokens?: number;
  /** Output tokens generated by sub-agents */
  subagent_output_tokens?: number;
  /** Sub-agent input tokens served from cache */
  subagent_cache_read_tokens?: number;
  /** Sub-agent input tokens written to cache */
  subagent_cache_write_tokens?: number;
  /** Sub-agent invocations in this turn */
  subagent_calls?: number;
  /** Model the sub-agents ran on, when they all ran on the same one. Sub-agents are independently configurable, so their tokens must not be priced as the parent's model */
  subagent_model_id?: string;
  /** Prompt size on the final LLM cycle (input + cache read + cache write); None when the SDK reported no per-cycle usage */
  context_tokens?: number;
  /** Model context window; None when the AgentSpec declares none */
  max_context_tokens?: number;
  /** Event-loop cycles (LLM calls) in this turn */
  cycle_count?: number;
  /** Accumulated model latency for this turn */
  latency_ms?: number;
  /** Messages folded into a summary during this turn. Non-zero means the agent no longer holds those messages verbatim, which the transcript must say */
  compacted_messages?: number;
}

/**
 * Lifetime token totals for an investigation across every completed turn
 */
export interface InvestigationTokenTotals {
  /** Uncached input tokens across all turns */
  input_tokens?: number;
  /** Output tokens across all turns */
  output_tokens?: number;
  /** Input tokens served from cache across all turns */
  cache_read_tokens?: number;
  /** Input tokens written to cache across all turns */
  cache_write_tokens?: number;
  /** Sub-agent uncached input tokens across all turns */
  subagent_input_tokens?: number;
  /** Sub-agent output tokens across all turns */
  subagent_output_tokens?: number;
  /** Sub-agent cache-read tokens across all turns */
  subagent_cache_read_tokens?: number;
  /** Sub-agent cache-write tokens across all turns */
  subagent_cache_write_tokens?: number;
  /** Sub-agent invocations across all turns */
  subagent_calls?: number;
  /** Event-loop cycles across all turns */
  cycle_count?: number;
  /** Messages summarised away across all turns; how much of this investigation the agent no longer holds verbatim */
  compacted_messages?: number;
  /** Completed agent turns that reported usage */
  turn_count?: number;
  /** ISO 8601 timestamp of the last accumulated turn */
  updated_at?: string;
}

/**
 * Full investigation data with all related items
 */
export interface Investigation {
  /** Investigation ID (must start with 'inv-') */
  id: string;
  /** Customer ID owning this investigation */
  customer_id: string;
  /** AWS accounts in investigation scope */
  scope: InvestigationScope[];
  /** Investigation title */
  title: string;
  /** Investigation description */
  description: string;
  /** Attached knowledge items */
  knowledge_items: KnowledgeItem[];
  /** Investigation findings */
  findings: Finding[];
  /** Investigation lifecycle state */
  state: InvestigationStateType;
  /** Investigation resolution details (required when state=completed) */
  resolution?: string;
  /** ISO 8601 timestamp */
  created_at: string;
  /** ISO 8601 timestamp */
  updated_at: string;
  /** Playbook reference (if using playbook) */
  playbook?: PlaybookReference;
  /** Current agent execution status */
  agent_status: AgentStatusType;
  /** ISO 8601 timestamp of last agent activity */
  last_agent_activity?: string;
  /** Incremented on conversation clear to create fresh memory sessions */
  conversation_version: number;
  /** Lifetime token totals across every completed turn; None until the first turn completes */
  token_usage_total?: InvestigationTokenTotals;
  /** Interactive agent that works this investigation; keys its conversations */
  agent_id: string;
}

/**
 * Lightweight investigation for the list surface (no findings/knowledge_items)
 */
export interface InvestigationSummary {
  /** Investigation ID (must start with 'inv-') */
  id: string;
  /** Customer ID owning this investigation */
  customer_id: string;
  /** AWS accounts in investigation scope */
  scope: InvestigationScope[];
  /** Investigation title */
  title: string;
  /** Investigation description */
  description: string;
  /** Investigation lifecycle state */
  state: InvestigationStateType;
  /** Investigation resolution details (required when state=completed) */
  resolution?: string;
  /** ISO 8601 timestamp */
  created_at: string;
  /** ISO 8601 timestamp */
  updated_at: string;
  /** Playbook reference (if using playbook) */
  playbook?: PlaybookReference;
  /** Current agent execution status */
  agent_status: AgentStatusType;
  /** ISO 8601 timestamp of last agent activity */
  last_agent_activity?: string;
  /** Incremented on conversation clear to create fresh memory sessions */
  conversation_version: number;
  /** Lifetime token totals across every completed turn; None until the first turn completes */
  token_usage_total?: InvestigationTokenTotals;
}

/**
 * Per-customer Freshservice routing configuration (ADR-0037)
 */
export interface ItsmConfig {
  /** ITSM vendor */
  provider?: string;
  /** Freshservice Company id (sent as department_id) */
  company_id: number;
  /** Default agent group within the Company */
  default_group_id?: number;
  /** Default agent the ticket is assigned to; unset leaves it unassigned */
  default_responder_id?: number;
  /** Default requester id for OpsPilot-generated tickets */
  requester_id?: number;
  /** Fallback requester email when requester_id is not set */
  requester_email?: string;
}

/**
 * Customer account with operations configuration
 */
export interface Customer {
  id: string;
  name: string;
  operations_account_id: string;
  operations_account_role?: string;
  operations_account_write_role?: string;
  operations_account_automation_role?: string;
  operations_account_dataset_role?: string;
  operations_account_external_id?: string;
  operations_account_region: string;
  operations_event_bus_name?: string;
  knowledge_base_id?: string;
  knowledge_base_bucket?: string;
  contact_types: string[];
  portal_url?: string;
  jit_required: boolean;
  itsm_config?: ItsmConfig;
  entra_group_id?: string;
  onboarded_at?: string;
  created_at: string;
  updated_at: string;
}

/**
 * AWS account configuration for customer
 */
export interface AwsAccount {
  id: string;
  customer_id: string;
  aws_account_id: string;
  account_name: string;
  read_role_name: string;
  write_role_name: string;
  automation_role_name?: string;
  onboarding_role_name?: string;
  external_id: string;
  main_region: string;
  supported_regions: string[];
  event_bus_name: string;
  last_call_home_at?: string;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

/**
 * Knowledge base metadata
 */
export interface KnowledgeBase {
  id: string;
  name: string;
  description: string;
}

/**
 * List of available knowledge bases
 */
export interface KnowledgeBaseListResponse {
  knowledge_bases: KnowledgeBase[];
}

/**
 * Request to create a new prompt
 */
export interface PromptCreateRequest {
  /** Prompt name */
  name: string;
  /** Human-readable title (shown in UI) */
  title: string;
  /** Prompt type */
  type?: PromptTypeType;
  /** Prompt description */
  description?: string;
  /** Prompt content (markdown) */
  content: string;
  /** AWS account scope (required for playbook type) */
  accountScope?: PromptAccountScopeType;
  /** Tags for categorization */
  tags?: string[];
  /** Which invocation shape(s) can use this skill: interactive, batch or both */
  agentType?: SkillApplicabilityType;
}

/**
 * Request to update an existing prompt
 */
export interface PromptUpdateRequest {
  /** Prompt name (alphanumeric, underscores, hyphens) */
  name?: string;
  /** Human-readable title (shown in UI) */
  title?: string;
  /** Prompt description */
  description?: string;
  /** Prompt content (markdown) */
  content?: string;
  /** AWS account scope */
  accountScope?: PromptAccountScopeType;
  /** Tags for categorization */
  tags?: string[];
  /** Which invocation shape(s) can use this skill: interactive, batch or both */
  agentType?: SkillApplicabilityType;
}

/**
 * Prompt response model (merged from DynamoDB + Prompt Manager)
 */
export interface Prompt {
  /** Unique prompt ID */
  id: string;
  /** Prompt name (alphanumeric, underscores, hyphens) */
  name: string;
  /** Human-readable title (shown in UI) */
  title: string;
  /** Prompt type */
  type: PromptTypeType;
  /** Prompt description */
  description: string;
  /** Prompt content retrieved from Prompt Manager (null in list responses) */
  content?: string;
  /** Owner type: customer or global */
  owner: PromptOwnerType;
  /** Customer ID (only if owner=customer) */
  customerId?: string;
  /** AWS account scope (playbook type only) */
  accountScope?: PromptAccountScopeType;
  /** Which invocation shape(s) can use this skill: interactive, batch or both */
  agentType?: SkillApplicabilityType;
  /** Tags for categorization */
  tags: string[];
  /** AWS Prompt Manager ARN */
  promptArn: string;
  /** AWS Prompt Manager ID (10-char) */
  promptId: string;
  /** Active published version (read-only): 1, 2, 3... */
  promptVersion?: string;
  /** All available versions from Bedrock */
  availableVersions: string[];
  /** Template variables found in content */
  variables: string[];
  /** ISO 8601 timestamp */
  createdAt: string;
  /** ISO 8601 timestamp */
  updatedAt: string;
  /** User email who created this prompt */
  createdBy?: string;
}

/**
 * Request to test-run prompt content against the model (no side effects)
 */
export interface PromptTestRequest {
  /** Customer context for prompt resolution and authorization */
  customer_id: string;
  /** Resolve a stored prompt by ID (used when content is absent) */
  prompt_id?: string;
  /** Inline draft content to run as-is */
  content?: string;
  /** Values rendered into {placeholder} tokens */
  variables?: Record<string, string>;
  /** Type of the draft being tested. Only needed on the inline-content path, where there is no stored prompt to read it from; a type with an output contract (e.g. enrichment) is tested against that contract. */
  prompt_type?: PromptTypeType;
  /** The pipeline use whose bound model runs the test; required unless the prompt type determines it. */
  model_use?: ModelUseType;
}

/**
 * Model output from a prompt test run
 */
export interface PromptTestResponse {
  /** Raw model response text */
  output: string;
  /** Non-fatal issues, e.g. placeholders with no value */
  warnings: string[];
  /** Name of the output contract this run was validated against, when the prompt type has one */
  contract_checked?: string;
  /** Field-level contract violations; empty when the output satisfies the contract */
  contract_errors: string[];
}

/**
 * Per-agent tool loadout: selected catalog action_ids + non-catalog block keys + AVP visibility flag
 */
export interface ToolLoadout {
  tools?: string[];
  blocks?: string[];
  avp_visibility_filter?: boolean;
}

/**
 * Global agent model + tuning config (one row per agent)
 */
export interface AgentSpec {
  agent_id: string;
  shape: InvocationShapeType;
  status: AgentLifecycleType;
  callees: string[];
  display_name: string;
  description: string;
  model_id?: string;
  context_window_size?: number;
  requires_context_window?: boolean;
  thinking_effort?: string;
  max_tokens?: number;
  system_prompt_ref?: string;
  tool_loadout?: ToolLoadout;
  updated_at: string;
  updated_by?: string;
}

/**
 * A retired agent's row, and the active agents that still name it as a callee (PS-UC-18)
 */
export interface RetireAgentResult {
  agent: AgentSpec;
  named_as_callee_by: string[];
}

/**
 * The investigation agent and the automation agent a Prompt Studio admin sets (PO 2026-10-28)
 */
export interface DefaultAgents {
  /** The investigation agent */
  interactive: string;
  /** The automation agent */
  batch: string;
  /** When a default last changed; None before any change */
  updated_at?: string;
  /** Who last changed a default */
  updated_by?: string;
}

/**
 * Make an active interactive or batch agent the default of its shape
 */
export interface SetDefaultAgentRequest {
  /** interactive or batch */
  shape: InvocationShapeType;
  /** An active agent of that shape */
  agent_id: string;
}

/**
 * A catalog tool offered to an agent kind, and why the wall will refuse it where the agent runs (ADR-0071)
 */
export interface OfferedTool {
  action_id: string;
  /** Why calls to it will be refused where an agent of this kind runs; None when they may pass */
  warning?: string;
}

/**
 * One invocation shape, what it decides, and every tool offered to it with its warning (ADR-0071)
 */
export interface InvocationShapeInfo {
  shape: InvocationShapeType;
  /** Who an agent of this shape acts as */
  principal: string;
  /** What it remembers across turns */
  memory: string;
  /** How its answer reaches whoever invoked it */
  delivery: string;
  /** What may invoke it */
  invoked_by: string;
  /** Every tool offered to an agent of this shape, sorted by id */
  tools: OfferedTool[];
}

/**
 * The shape whose active agents a picker offers
 */
export interface ListRunnableAgentsRequest {
  shape: InvocationShapeType;
}

/**
 * An active agent as a picker shows it: id, name and description only
 */
export interface RunnableAgent {
  agent_id: string;
  display_name: string;
  description: string;
}

/**
 * Partial update of one agent's spec (only supplied tunables change)
 */
export interface AgentSpecUpdateRequest {
  agent_id: string;
  display_name?: string;
  description?: string;
  model_id?: string;
  context_window_size?: number;
  requires_context_window?: boolean;
  thinking_effort?: string;
  max_tokens?: number;
  system_prompt_ref?: string;
  tool_loadout?: ToolLoadout;
  callees?: string[];
}

/**
 * Request params identifying one agent spec to read
 */
export interface GetAgentSpecRequest {
  agent_id: string;
}

/**
 * The model one non-agent LLM use runs on (one row per use, PS-UC-17)
 */
export interface ModelBinding {
  use: ModelUseType;
  model_id: string;
  updated_at: string;
  updated_by?: string;
}

/**
 * Set the model one use runs on (EU inference profile only)
 */
export interface ModelBindingUpdateRequest {
  use: ModelUseType;
  model_id: string;
}

/**
 * One model an agent may be set to, and whether this account can run it
 */
export interface AvailableModel {
  /** The EU inference profile id, as a spec stores it */
  model_id: string;
  /** The model's display name, or the id when it has none */
  label: string;
  /** Whether this account can call it right now */
  available: boolean;
  /** Why it cannot be called; None when it can */
  reason?: string;
}

/**
 * The toolbox an agent runs today, and whether it is stored or the baseline
 */
export interface EffectiveLoadout {
  agent_id: string;
  tools?: string[];
  blocks?: string[];
  avp_visibility_filter?: boolean;
  /** The only tools this agent can be given: the offer for its shape, which is the list the write boundary checks, so an editor offering anything else would offer a choice the save refuses. */
  selectable: string[];
}

/**
 * One grader in an eval case's spec (builtin evaluator ref or code assertion)
 */
export interface GraderSpec {
  kind: string;
  grader_id: string;
  reference?: Record<string, any>;
  weight?: number;
}

/**
 * A versioned, agent-agnostic eval case: input scenario + success criteria + grader spec
 */
export interface EvalCase {
  case_id: string;
  version?: number;
  title: string;
  description?: string;
  input: Record<string, any>;
  success_criteria: string;
  graders?: GraderSpec[];
  reference_solution?: Record<string, any>;
  scoring_policy?: string;
  tags?: string[];
  status?: string;
  created_at: string;
  created_by?: string;
  updated_at: string;
  updated_by?: string;
}

/**
 * Author a new eval case (write boundary: >=1 grader, no trajectory matchers)
 */
export interface AuthorEvalCaseRequest {
  title: string;
  description?: string;
  input: Record<string, any>;
  success_criteria: string;
  graders: GraderSpec[];
  reference_solution?: Record<string, any>;
  scoring_policy?: string;
  tags?: string[];
}

/**
 * Request params identifying one eval case to read (latest version)
 */
export interface GetEvalCaseRequest {
  case_id: string;
}

/**
 * One run of an agent config against an eval case (status, transcript, outcome, grade)
 */
export interface Trial {
  trial_id: string;
  case_id: string;
  case_version: number;
  agent_id: string;
  config_ref?: Record<string, any>;
  status?: string;
  runtime_session_id?: string;
  invoked_at?: string;
  completed_at?: string;
  outcome?: Record<string, any>;
  transcript_ref?: Record<string, any>;
  grade?: Record<string, any>;
  error?: string;
  created_at: string;
  created_by?: string;
  updated_at: string;
}

export const WorkflowStatus = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
} as const;

export type WorkflowStatusType = typeof WorkflowStatus[keyof typeof WorkflowStatus];

export const WorkflowNodeKind = {
  STEP: 'step',
  DECISION: 'decision',
} as const;

export type WorkflowNodeKindType = typeof WorkflowNodeKind[keyof typeof WorkflowNodeKind];

/**
 * The structure a run walks: nodes with their layers and routes
 */
export interface WorkflowPlan {
  nodes: WorkflowNode[];
}

/**
 * One version of a layered workflow definition (ADR-0055): nodes, layers, gates
 */
export interface Workflow {
  nodes: WorkflowNode[];
  workflow_id: string;
  /** 'DRAFT' or a positive integer as a string */
  version: string;
  /** Stable snake_case key */
  name: string;
  title: string;
  description?: string;
  status?: WorkflowStatusType;
  tags?: string[];
  created_at: string;
  updated_at: string;
  created_by?: string;
}

/**
 * Listing projection of a workflow: identity and shape without the node bodies
 */
export interface WorkflowSummary {
  workflow_id: string;
  version: string;
  name: string;
  title: string;
  description: string;
  status: WorkflowStatusType;
  node_count: number;
  layer_count: number;
  gate_count: number;
  tags?: string[];
  created_at: string;
  updated_at: string;
}

export const NodeState = {
  PENDING: 'pending',
  DONE: 'done',
  PRUNED: 'pruned',
  FAILED: 'failed',
} as const;

export type NodeStateType = typeof NodeState[keyof typeof NodeState];

export const RunStatus = {
  RUNNING: 'running',
  AWAITING_GATE: 'awaiting_gate',
  BLOCKED: 'blocked',
  COMPLETED: 'completed',
  ABANDONED: 'abandoned',
} as const;

export type RunStatusType = typeof RunStatus[keyof typeof RunStatus];

export const GateResolution = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type GateResolutionType = typeof GateResolution[keyof typeof GateResolution];

export const FailureCause = {
  REPORTED: 'reported',
  ACCESS: 'access',
} as const;

export type FailureCauseType = typeof FailureCause[keyof typeof FailureCause];

/**
 * Immutable pointer from a run to the exact version it walks
 */
export interface WorkflowRef {
  workflow_id: string;
  /** The published version this run is pinned to */
  version: string;
  name: string;
  title: string;
}

/**
 * One request for human approval on a gated step, and its answer
 */
export interface GateRecord {
  node_id: string;
  /** Why the agent is asking */
  reason: string;
  requested_at: string;
  resolution?: GateResolutionType;
  resolved_by?: string;
  resolved_at?: string;
  note?: string;
}

/**
 * The branch a decision took, and the ones it pruned
 */
export interface DecisionRecord {
  node_id: string;
  chosen_condition: string;
  target_layer: number;
  /** Why this branch, in the agent's words */
  reason: string;
  /** The conditions whose stages this choice skipped. A condition targeting a later stage than the chosen one is absent: the run reaches that stage either way */
  pruned_conditions?: string[];
  decided_at: string;
}

/**
 * A step that failed, why (reported or access), and who sent it back
 */
export interface FailureRecord {
  node_id: string;
  /** What went wrong, and what to do about it */
  error: string;
  cause?: FailureCauseType;
  failed_at: string;
  retried_by?: string;
  retried_at?: string;
}

/**
 * One node the agent may work on now, with its gate state
 */
export interface WorkflowStepView {
  node_id: string;
  label: string;
  goal: string;
  layer: number;
  kind: WorkflowNodeKindType;
  gate: boolean;
  /** 'awaiting' when a gate is open, 'approved' once cleared */
  gate_state?: string;
  /** For a decision: the routes it may take */
  branch_conditions?: string[];
  /** Facts this step must record to complete; completing without one is refused */
  evidence_required?: string[];
}

/**
 * One tool a step grants, in its mode, and whether the operator may use it
 */
export interface StepToolAccess {
  tool: string;
  mode?: string;
  /** As written in allowed_tools terms: 'tool' or 'tool:mode' */
  grant: string;
  permitted: boolean;
  reason: string;
  /** False when the check faulted, so 'not permitted' is an unknown */
  checked?: boolean;
}

/**
 * Whether the operator's access covers one step, and whether every run reaches it
 */
export interface StepAccess {
  node_id: string;
  label: string;
  layer: number;
  /** True when every run reaches this step whatever its decisions choose */
  mandatory: boolean;
  permitted: boolean;
  /** Why the step would fail; None when permitted */
  reason?: string;
  tools?: StepToolAccess[];
}

/**
 * A workflow's access needs against one operator's access on one customer
 */
export interface WorkflowAccessReport {
  workflow: string;
  title: string;
  version: string;
  customer_id: string;
  /** 'l1', 'l2', 'admin', or 'none' */
  effective_level: string;
  /** False when a step every run reaches needs access the operator lacks */
  startable: boolean;
  steps: StepAccess[];
}

/**
 * What a caller learns after reading or advancing a run
 */
export interface WorkflowRunState {
  run_id: string;
  status: RunStatusType;
  current_layer: number;
  layer_count?: number;
  definition_missing?: boolean;
  node_states?: Record<string, NodeStateType>;
  steps?: WorkflowStepView[];
  /** The workflow's name, when the caller asked */
  workflow?: string;
  /** On start only: steps some routes reach that the operator's access does not cover. They do not block the start; the run blocks if it reaches one. */
  access_warnings?: StepAccess[];
}

/**
 * One walk of one pinned workflow version inside an investigation
 */
export interface WorkflowRun {
  run_id: string;
  customer_id: string;
  workflow_ref: WorkflowRef;
  /** The batch session walking this run, which that session alone is bound by. None for a run an investigation reaches, which is bound through the link instead */
  agent_session_id?: string;
  current_layer?: number;
  node_states?: Record<string, NodeStateType>;
  evidence?: Record<string, string>;
  /** Per node, the facts its definition required, keyed as the definition named them */
  facts?: Record<string, Record<string, string>>;
  decisions?: DecisionRecord[];
  gates?: GateRecord[];
  failures?: FailureRecord[];
  status?: RunStatusType;
  started_at: string;
  updated_at: string;
  completed_at?: string;
}

/**
 * One run with the definition it is walking, absent when that version was deleted
 */
export interface WorkflowRunDetail {
  run: WorkflowRun;
  plan?: WorkflowPlan;
  definition_missing?: boolean;
}

/**
 * Listing projection of a run: progress without evidence
 */
export interface WorkflowRunSummary {
  run_id: string;
  workflow_name: string;
  workflow_title: string;
  workflow_version: string;
  status: RunStatusType;
  current_layer: number;
  layer_count?: number;
  definition_missing?: boolean;
  nodes_done: number;
  nodes_total: number;
  awaiting_gate_on?: string;
  /** The gated step's label; None when nothing waits or the plan is gone */
  awaiting_gate_on_label?: string;
  failed_on?: string;
  /** The failed step's label; None when nothing failed or the plan is gone */
  failed_on_label?: string;
  /** Why the run is blocked: an agent report, or the operator's access */
  failed_cause?: FailureCauseType;
  /** Labels of the steps the run is on right now, including a gated step that is waiting on a person. Empty when the run is completed, abandoned or blocked, and when the plan is gone. A stage's members are unordered, so every eligible one is named rather than one of them chosen */
  current_step_labels?: string[];
  started_at: string;
  updated_at: string;
}

/**
 * One runnable workflow as the launcher sees it: enough to pick, not enough to walk
 */
export interface WorkflowCatalogEntry {
  workflow_id: string;
  name: string;
  title: string;
  description: string;
  version: string;
  node_count: number;
  layer_count: number;
}

/**
 * What a workflow delete reports: which workflow, and how many rows actually went
 */
export interface WorkflowDeleted {
  workflow_id: string;
  versions_deleted: number;
}

/**
 * Start a trial — run a case's agent config in the real harness
 */
export interface StartTrialRequest {
  case_id: string;
  agent_id?: string;
}

/**
 * Request params identifying one trial to read
 */
export interface GetTrialRequest {
  trial_id: string;
}

/**
 * Request params for trial:ListTrials — every trial for one case, newest first
 */
export interface ListTrialsRequest {
  case_id: string;
}

/**
 * Grade a completed trial — the write boundary for trial:GradeTrial
 */
export interface GradeTrialRequest {
  trial_id: string;
}

/**
 * The outcome of running one grader from a case's grader spec against a trial
 */
export interface GraderResult {
  grader_id: string;
  kind: string;
  passed?: boolean;
  score?: number;
  label?: string;
  explanation?: string;
  error?: string;
}

/**
 * The combined grade for one trial — the per-grader results plus the aggregate
 */
export interface TrialGrade {
  results?: GraderResult[];
  aggregate_passed?: boolean;
  aggregate_score?: number;
  scoring_policy: string;
  incomplete?: boolean;
}

/**
 * Persisted overlay on a code-defined tool (operator-set deltas)
 */
export interface ToolConfig {
  action_id: string;
  description_override?: string;
  enabled?: boolean;
  updated_at: string;
  updated_by?: string;
}

/**
 * Partial update of one tool's config overlay
 */
export interface ToolConfigUpdateRequest {
  action_id: string;
  description_override?: string;
  enabled?: boolean;
}

/**
 * Request params scoping a prompt query to one customer
 */
export interface CustomerScopeRef {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params identifying one customer-owned prompt
 */
export interface CustomerPromptRef {
  /** Customer ID */
  customer_id: string;
  /** Prompt ID */
  prompt_id: string;
}

/**
 * Request params identifying one version of a customer-owned prompt
 */
export interface CustomerPromptVersionRef {
  /** Customer ID */
  customer_id: string;
  /** Prompt ID */
  prompt_id: string;
  /** Version identifier */
  version: string;
}

/**
 * Request params identifying one global prompt
 */
export interface GlobalPromptRef {
  /** Prompt ID */
  prompt_id: string;
}

/**
 * Request params identifying one version of a global prompt
 */
export interface GlobalPromptVersionRef {
  /** Prompt ID */
  prompt_id: string;
  /** Version identifier */
  version: string;
}

/**
 * Result of a single hop in role assumption chain
 */
export interface RoleAssumeHopResult {
  /** Whether this hop succeeded */
  success: boolean;
  /** Role ARN that was assumed (if successful) */
  role_arn?: string;
  /** Session name used */
  session_name?: string;
  /** Credential expiration (ISO 8601) */
  expiration?: string;
  /** Error message (if failed) */
  error_message?: string;
  /** AWS error code (if failed) */
  error_code?: string;
}

/**
 * Complete role validation test result with hop-by-hop tracking
 */
export interface RoleValidationResult {
  /** Overall validation success */
  success: boolean;
  /** Type of validation: 'operations_role' or 'customer_role' */
  validation_type: string;
  /** Customer ID */
  customer_id: string;
  /** AWS account ID (internal ID, for customer role validation) */
  account_id?: string;
  /** Role type tested: 'readonly' or 'write' */
  role_type?: string;
  /** AWS operation that was tested */
  aws_operation: Record<string, any>;
  /** Hop 1: Lambda → Operations Account */
  hop1_operations_account?: RoleAssumeHopResult;
  /** Hop 2: Operations Account → Customer Account */
  hop2_customer_account?: RoleAssumeHopResult;
  /** Result of test AWS operation (if successful) */
  operation_result?: Record<string, any>;
  /** Human-readable error message */
  error_message?: string;
  /** Which hop failed (1 or 2) */
  failed_at_hop?: number;
}

/**
 * Request for time-boxed privilege escalation
 */
export interface EscalationRequest {
  requested_level: 'l2' | 'admin';
  duration_minutes: 15 | 30 | 120 | 240 | 480;
}

/**
 * Privilege escalation record with status and timing
 */
export interface EscalationResponse {
  customer_id: string;
  user_id: string;
  user_email?: string;
  escalation_level: 'l2' | 'admin';
  status: 'pending' | 'active' | 'expired' | 'revoked';
  requested_at: string;
  granted_at?: string;
  expires_at?: string;
  granted_by: string;
  duration_minutes: number;
}

/**
 * Request params scoping an action to one customer
 */
export interface CustomerScopedRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params identifying one AWS account record on a customer
 */
export interface CustomerAccountRequest {
  /** Customer ID */
  customer_id: string;
  /** Internal AWS account record ID (from list_aws_accounts) */
  account_id: string;
}

/**
 * Request params identifying a customer plus a target user id (Cognito sub)
 */
export interface CustomerUserIdRequest {
  customer_id: string;
  user_id: string;
}

/**
 * Request params identifying one operator user by username
 */
export interface GetUserRequest {
  /** Username */
  username: string;
}

/**
 * Request params for adding/removing a user's authorization groups
 */
export interface UpdateUserGroupsRequest {
  username: string;
  add_groups?: string[];
  remove_groups?: string[];
}

/**
 * Request params identifying one Cedar policy
 */
export interface GetPolicyRequest {
  policy_id: string;
}

// ============================================================================
// Authorization / User Management Models
// ============================================================================

/**
 * Cognito user with group memberships
 */
export interface CognitoUser {
  username: string;
  email: string;
  name: string;
  status: string;
  enabled: boolean;
  created_at: string;
  groups: string[];
  entra_groups: string[];
  access_groups: string[];
  sso_groups: string[];
  claim_groups?: string[];
  phone_number?: string;
  customer_id?: string;
}

/**
 * Request to add/remove user group memberships
 */
export interface GroupUpdate {
  add_groups?: string[];
  remove_groups?: string[];
}

/**
 * Cedar authorization policy from AVP
 */
export interface CedarPolicy {
  policy_id: string;
  policy_type: string;
  description?: string;
  statement: string;
  created_at: string;
  last_updated_at: string;
}

// ============================================================================
// Async Execution / Reconciler Models
// ============================================================================

/**
 * Reconciler action to be executed
 */
export interface Action {
  action_type: string;
  resource_id: string;
  params?: Record<string, any>;
  display_name?: string;
  description?: string;
}

/**
 * Ordered group of actions to execute together
 */
export interface ActionGroup {
  order: number;
  actions: Action[];
}

/**
 * Reconciler plan with action groups
 */
export interface Plan {
  no_change?: boolean;
  groups?: ActionGroup[];
  reason?: string;
  summary?: string;
}

/**
 * Result of executing a reconciler action
 */
export interface ActionResult {
  success: boolean;
  action_type: string;
  resource_id: string;
  display_name?: string;
  error?: string;
  error_detail?: string;
  failure_class?: string;
  summary?: string;
  updated_actual?: Record<string, any>;
}

/**
 * A single drift observation from the verify phase
 */
export interface DriftObservation {
  category: string;
  subject: string;
  summary: string;
  expected?: string;
  actual?: string;
}

/**
 * Result of reconciler verification phase
 */
export interface VerifyResult {
  outcome: VerifyOutcomeType;
  summary?: string;
  observations?: DriftObservation[];
}

/**
 * Timing for a reconciler plumbing step
 */
export interface PlumbingStep {
  state: string;
  display_name: string;
  duration_ms: number;
}

/**
 * Per-phase timing breakdown for a reconciler execution
 */
export interface ReconcilerTiming {
  plan_ms?: number;
  apply_ms?: number;
  verify_ms?: number;
  total_ms?: number;
  plumbing?: PlumbingStep[];
}

/**
 * Structured phases of a reconciler execution
 */
export interface ReconcilerPhases {
  plan?: Plan;
  apply?: ActionResult[];
  verify?: VerifyResult;
  outcomes?: Record<string, PhaseOutcomeType>;
}

/**
 * Full detail of a reconciler execution with phases and timing
 */
export interface ReconcilerExecutionDetail {
  execution_arn: string;
  reconciler_name: string;
  reconciler_description?: string;
  resource_id: string;
  resource_label?: string;
  status: string;
  started_at?: string;
  completed_at?: string;
  total_ms?: number;
  phases?: ReconcilerPhases;
  timing?: ReconcilerTiming;
  error?: string;
  cause?: string;
  history_available?: boolean;
  history_unavailable_reason?: string;
}

/**
 * One reconciled resource's convergence + backoff state for the kernel view
 */
export interface ReconcilerResource {
  domain_type: string;
  resource_id: string;
  status: string;
  execution_id?: string;
  updated_at: string;
  failure_class?: string;
  attempt?: number;
  consecutive_failures?: number;
  terminal?: boolean;
  condition?: string;
  last_error?: string;
  failed_at?: string;
  next_retry_at?: string;
  drift_age_seconds?: number;
}

/**
 * One bounded page of reconciler resources plus an opaque next_token
 */
export interface ReconcilerResourcePage {
  resources?: ReconcilerResource[];
  next_token?: string;
}

/**
 * Counts-only rollup for a reconciler domain with failure-shape cross-cuts
 */
export interface ReconcilerSummary {
  domain_type: string;
  reconciler_name: string;
  total?: number;
  converged?: number;
  settling?: number;
  failed?: number;
  in_progress?: number;
  pending?: number;
  by_failure_class?: Record<string, number>;
  terminal?: number;
  stuck?: number;
  throttled?: number;
}

// ============================================================================
// Kernel Control-Plane Health Models
// ============================================================================

/**
 * EventBridge schedule health for a reconciler
 */
export interface ScheduleHealth {
  trigger_kind: TriggerKindType;
  rate?: string;
  rule_name?: string;
  source?: string;
  enabled?: boolean;
  last_tick?: string;
  next_tick?: string;
}

/**
 * Schedule invocation health for a reconciler
 */
export interface InvocationHealth {
  firing?: boolean;
  invocations?: number;
  failed_invocations?: number;
  has_data?: boolean;
}

/**
 * Per-resource convergence counts for a reconciler
 */
export interface ConvergenceHealth {
  converged?: number;
  settling?: number;
  drifted?: number;
  failed?: number;
  in_progress?: number;
  pending?: number;
  unknown?: number;
  failed_stale?: number;
  failed_by_class?: Record<string, number>;
  terminal?: number;
}

/**
 * A single CloudWatch alarm name + state
 */
export interface AlarmSummary {
  name: string;
  state: 'OK' | 'ALARM' | 'INSUFFICIENT_DATA' | 'MISSING';
  exists?: boolean;
}

/**
 * Recent Step Functions execution health for a reconciler
 */
export interface RecentHealth {
  last_run?: string;
  failure_rate?: number;
  execution_count?: number;
  timed_out?: number;
  aborted?: number;
  has_data?: boolean;
}

/**
 * One failed resource behind a DEGRADED verdict (deep lens drill-down)
 */
export interface ReconcilerFailure {
  resource_id: string;
  error?: string;
  failed_at?: string;
  stale?: boolean;
  failure_class?: string;
  terminal?: boolean;
  attempt?: number;
}

/**
 * Canonical reconciler-machine health verdict with all fused signals
 */
export interface ReconcilerHealth {
  domain: string;
  description?: string;
  overall: 'HEALTHY' | 'IDLE' | 'DEGRADED' | 'DOWN' | 'UNKNOWN';
  reason?: string;
  schedule: ScheduleHealth;
  invocation: InvocationHealth;
  convergence: ConvergenceHealth;
  alarms?: AlarmSummary[];
  recent: RecentHealth;
  phases?: string[];
  failures?: ReconcilerFailure[];
}

/**
 * A reconciler's health as seen by one customer, after the platform overlay
 */
export interface CustomerReconcilerHealth {
  domain: string;
  customer_id: string;
  overall: 'HEALTHY' | 'IDLE' | 'DEGRADED' | 'DOWN' | 'UNKNOWN';
  machine_overall: 'HEALTHY' | 'IDLE' | 'DEGRADED' | 'DOWN' | 'UNKNOWN';
  convergence: ConvergenceHealth;
  blocked_by_platform?: boolean;
}

/**
 * Per-reconciler control-plane health for a single customer
 */
export interface CustomerControlPlane {
  customer_id: string;
  reconcilers?: CustomerReconcilerHealth[];
  skipped_domains?: string[];
}

// ============================================================================
// Service Catalog Models
// ============================================================================

/**
 * CFN template parameter metadata discovered at artifact registration
 */
export interface CfnParameter {
  key: string;
  type?: string;
  allowed_values?: string[];
  allowed_pattern?: string;
  default?: string;
  has_default?: boolean;
}

/**
 * A version of a product in AWS Service Catalog
 */
export interface ServiceComponentVersion {
  /** Version name (e.g., 'v1.2.3') */
  name: string;
  /** Per-region AWS SC Provisioning Artifact IDs (region -> pa-...) */
  sc_artifact_ids?: Record<string, string>;
  /** When this version was created (ISO 8601) */
  created_time: string;
  /** Whether this version is active/available for deployment */
  active: boolean;
  /** CFN parameter metadata discovered at register time */
  cfn_parameters: CfnParameter[];
  /** Author workspace — per-key binding rules for each CFN parameter. Mutable until snapshotted into a ServiceManifest. */
  bindings?: Record<string, any>;
  /** Opaque per-provisioner metadata (e.g. AWS SC artifact/product/portfolio IDs). Persistence writes flat sc_* fields until W4 migration. */
  provisioner_metadata?: Record<string, any>;
}

/**
 * ServiceComponent from AWS Service Catalog with Cloud2-managed metadata
 */
export interface ServiceComponent {
  /** Internal component ID (auto-generated, e.g., 'prod-237deae9-...'). Per-region SC product IDs are in sc_product_ids. */
  id: string;
  /** Service name from manifest (e.g., 'monitoring-baseline') */
  service: string;
  /** Portfolio name from manifest (e.g., 'cloud2-monitoring-operations') */
  portfolio: string;
  /** Component name (matches SC product name) */
  name: string;
  /** Component description from manifest */
  description: string;
  /** Deployment scope: 'global', 'regional', or specific region (e.g., 'eu-central-1') */
  scope: string;
  /** List of component names this depends on (from manifest) */
  depends_on: string[];
  /** Display order within portfolio (based on dependency graph) */
  order: number;
  /** If True, deploys automatically when customer subscribes to service. If False, requires explicit component selection (opt-in). */
  auto_deploy: boolean;
  /** Lifecycle status: active, deprecated, archived */
  status: ServiceComponentStatusType;
  /** Provisioning type: aws_service_catalog, terraform, manual, none. Defaults to the AWS Service Catalog adapter when unset. */
  provisioning_type?: string;
  /** GitHub repository URL for this component's source code */
  source_repository?: string;
  /** AWS Service Catalog Portfolio ID in source region (e.g., 'port-abc123') */
  portfolio_id?: string;
  /** Regional AWS SC portfolio IDs mapping region -> port-... */
  sc_portfolio_ids?: Record<string, string>;
  /** Regional AWS SC product IDs mapping region -> prod-... */
  sc_product_ids?: Record<string, string>;
  /** Current recommended version string (source of truth — per-region pa-... resolves via versions[*].sc_artifact_ids[region]) */
  current_version?: string;
  /** Available version history */
  versions: ServiceComponentVersion[];
  /** Creation timestamp (ISO 8601) */
  created_at: string;
  /** Last update timestamp (ISO 8601) */
  updated_at: string;
}

/**
 * Service Catalog deployment state with desired and actual tracking
 */
export interface Deployment {
  /** Deployment ID (UUID) */
  id: string;
  /** Customer ID */
  customer_id: string;
  /** AWS Account ID (12-digit) */
  account_id: string;
  /** AWS region */
  region: string;
  /** ServiceComponent ID */
  product_id: string;
  /** ServiceComponent name (denormalized) */
  product_name?: string;
  /** Service name (denormalized for queries) */
  service: string;
  /** Portfolio name (denormalized) */
  portfolio?: string;
  /** AWS SC Portfolio ID (denormalized) */
  portfolio_id?: string;
  /** Parent ServiceOffering ID (D-07). Empty on legacy rows; populated at creation time by the subscribe path from W3 onwards. W4 backfill populates existing rows. W5c makes this required. */
  offering_id: string;
  /** Neutral ServiceComponent ID (W4). Defaults to product_id in this context (they are the same identifier here). */
  component_id: string;
  desired_status: DeploymentStatusType;
  desired_version?: string;
  desired_parameters?: Record<string, any>;
  parameter_preview?: Record<string, any>;
  /** Operator-supplied source=input values only */
  input_overlay?: Record<string, any>;
  actual_status?: string;
  actual_version?: string;
  actual_artifact_id?: string;
  actual_provisioned_product_id?: string;
  actual_stack_id?: string;
  actual_parameters?: Record<string, any>;
  actual_outputs?: Record<string, string>;
  /** Provisioner's own explanation of actual_status, as reported by the heartbeat. The only channel by which a refusal on the customer side reaches this record. */
  actual_status_message?: string;
  drift_status: DriftStatusType;
  last_heartbeat?: string;
  /** When actual_version was first observed to differ from desired_version, cleared when they converge. Read as an age, not a flag: divergence is normal during an upgrade and only a defect once it persists. */
  version_drift_since?: string;
  last_action?: string;
  last_action_at?: string;
  last_action_result?: string;
  last_action_error?: string;
  last_action_request_id?: string;
  last_action_record_id?: string;
  blocked: boolean;
  blocked_reason?: string;
  drift_reason?: DriftReasonType;
  drift_reason_detail?: string;
  needs_reconcile: boolean;
  desired_state_sync_status?: DesiredStateSyncStatusType;
  desired_state_sync_at?: string;
  desired_state_sync_error?: string;
  reconcile_blocked_reason?: ReconcileBlockedReasonType;
  reconcile_blocking_dep?: string;
  compliance_status?: string;
  last_remediation_result?: Record<string, any>;
  rescue_required_since?: string;
  rescue_annotation?: string;
  dependency_order: number;
  /** Creation timestamp (ISO 8601) */
  created_at: string;
  /** Last update timestamp (ISO 8601) */
  updated_at: string;
}

/**
 * Deployment state change audit trail
 */
export interface DeploymentHistory {
  /** Composite: customer_id#account_id#product_id#region */
  deployment_id: string;
  /** Unique event ID (UUID) */
  event_id: string;
  /** Type of event */
  event_type: DeploymentHistoryEventTypeType;
  /** Event timestamp (ISO 8601) */
  timestamp: string;
  /** Version at time of event */
  version?: string;
  /** Status at time of event */
  status?: string;
  /** Action taken (if applicable) */
  action?: string;
  /** Result of action (if applicable) */
  result?: string;
  /** Error information (if applicable) */
  error_detail?: string;
  /** Event source: heartbeat, lifecycle, admin, system */
  source: string;
  /** Who/what triggered the event */
  actor?: string;
  /** Parameter values before the change */
  parameters_before?: Record<string, any>;
  /** Parameter values after the change */
  parameters_after?: Record<string, any>;
}

/**
 * List of deployments with total count
 */
export interface DeploymentListResponse {
  deployments: Deployment[];
  total_count: number;
}

/**
 * Per-dimension drift aggregation (total/in_sync/drifted)
 */
export interface DriftBucket {
  total?: number;
  in_sync?: number;
  drifted?: number;
}

/**
 * Cross-customer drift dashboard aggregation
 */
export interface DriftDashboard {
  total_deployments?: number;
  by_status?: Record<string, number>;
  by_service?: Record<string, any>;
}

/**
 * Error diagnostics for SC deployment with remediation steps
 */
export interface DeploymentErrorDiagnostics {
  /** Deployment composite ID */
  deployment_id: string;
  /** Classified error type */
  error_type: string;
  /** Original error message from Service Catalog */
  error_message: string;
  /** When error occurred (ISO 8601) */
  occurred_at: string;
  remediation_steps?: string[];
  related_resources?: Record<string, string>;
}

/**
 * Bulk action request for multiple deployments
 */
export interface BulkDeploymentActionRequest {
  /** List of deployment composite IDs */
  deployment_ids: string[];
  /** Action to perform */
  action: string;
  parameters?: Record<string, any>;
  actor?: string;
}

/**
 * Bulk action result with success/failure counts
 */
export interface BulkDeploymentActionResponse {
  requested: number;
  succeeded: number;
  failed: number;
  errors: Record<string, string>[];
}

/**
 * Result of service subscription with any warnings
 */
export interface SubscriptionResult {
  customer_id: string;
  account_id: string;
  services: string[];
  created: number;
  reactivated: number;
  skipped: number;
  optional_skipped?: number;
  optional_available?: string[];
  warnings?: string[];
}

/**
 * Result of service unsubscription with any warnings
 */
export interface UnsubscriptionResult {
  customer_id: string;
  services: string[];
  unsubscribed: number;
  warnings?: string[];
}

/**
 * Service offering definition grouping related products
 */
export interface ServiceDefinition {
  id: string;
  name: string;
  display_name: string;
  description: string;
  owner: string;
  category?: string;
  customer_description?: string;
  status: string;
  cloud_platforms: string[];
  sla_tier?: string;
  responsibility_summary?: Record<string, any>;
  created_at: string;
  updated_at: string;
}

/**
 * Immutable pointer to an asset in another bounded context
 */
export interface CrossContextRef {
  /** Owning bounded context (e.g. 'event_management') */
  target_context: string;
  /** Asset category (e.g. 'rule_template', 'prompt') */
  asset_type: string;
  /** Asset identifier within that context */
  asset_id: string;
  /** Role of this ref when used in prompt_refs (required for prompts, None for template_ref) */
  role?: 'enrichment' | 'automation';
}

/**
 * Immutable reference to a provisionable service component
 */
export interface ProvisionerRef {
  /** Provisioning system identifier */
  provisioner_kind: ProvisionerKindType;
  /** Opaque provider-specific reference (e.g. AWS SC product name) */
  ref: string;
}

/**
 * A discrete capability within a ServiceOffering that a customer can activate
 */
export interface ServiceCapability {
  /** Unique identifier within the offering */
  capability_id: string;
  /** Machine-readable name */
  name: string;
  /** Human-readable label */
  display_name: string;
  /** What this capability does */
  description?: string;
  /** Capability group tag (e.g. 'Baseline Monitoring'). One tag per capability. */
  group?: string;
  /** REACTIVE or INFORMATIONAL; None for infrastructure-only capabilities */
  rule_kind?: RuleKindType;
  /** Default alert priority; None for infrastructure-only capabilities */
  default_priority?: PriorityType;
  /** Cross-context reference to the rule template in event_management; None for infrastructure-only capabilities */
  template_ref?: CrossContextRef;
  /** Cross-context references to prompts in prompt_management */
  prompt_refs?: CrossContextRef[];
  /** Batch agent that runs the automation prompt ref (ADR-0064 decision 13); required with it. The pattern is spelled out because an aggregate imports no other context (ARCH-02); that it is an active batch agent is checked at save. */
  automation_agent_id?: string;
  /** Provisioner references required to provision this capability */
  enablement_refs?: ProvisionerRef[];
  /** capability_ids (within the same offering) that must be IN_SYNC before this capability is provisioned */
  depends_on?: string[];
}

/**
 * Immutable snapshot of an offering at publish time
 */
export interface ServiceManifest {
  /** Offering this manifest belongs to */
  offering_id: string;
  /** Offering version (semver) at publish time */
  version: string;
  /** Snapshot of all capabilities at publish time */
  capabilities: ServiceCapability[];
  /** Union of provisioner kinds required across all capability enablement_refs */
  enablement_provisioners: ProvisionerKindType[];
  /** Offering IDs that must be ACTIVE for a customer before this offering can be subscribed */
  requires_offerings?: string[];
  /** Responsibility matrix for this offering version */
  responsibility_matrix?: Record<string, any>;
  /** Snapshot of intra-offering capability dependency graph at publish time. Keys are capability_ids; values are their depends_on lists. */
  cap_dep_graph?: Record<string, string[]>;
  /** Per-component frozen provisioning snapshot (keyed by component_id). Copied from pinned ServiceComponentVersion at publish time. Reconciler reads bindings from here, not from live version. */
  component_provisioning?: Record<string, any>;
}

/**
 * Full ServiceOffering aggregate including capabilities
 */
export interface ServiceOffering {
  id: string;
  name: string;
  display_name: string;
  description?: string;
  owner?: string;
  category?: string;
  customer_description?: string;
  status?: string;
  version?: string;
  cloud_platforms?: string[];
  sla_tier?: string;
  responsibility_summary?: Record<string, any>;
  capabilities?: ServiceCapability[];
  requires_offerings?: string[];
  manifest?: ServiceManifest;
  created_at: string;
  updated_at: string;
}

/**
 * Operator-only per-customer adjustments for one capability
 */
export interface CapabilityOverride {
  /** Replace the capability's default_priority for this customer */
  priority_override?: PriorityType;
  /** Replace the capability's enrichment prompt reference for this customer */
  prompt_override?: CrossContextRef;
  /** Shallow patch applied on top of the capability's template_ref at plan time */
  template_override_patch?: Record<string, any>;
}

/**
 * Customer binding to a published ServiceOffering version
 */
export interface ServiceConfiguration {
  /** Customer this configuration belongs to */
  customer_id: string;
  /** ServiceOffering being subscribed to */
  offering_id: string;
  /** AWS account ID this configuration applies to. Empty in v1 (single-row invariant, W1). Populated at W4 DDB migration. */
  account_id?: string;
  /** SemVer of the published manifest this configuration pins to */
  pinned_offering_version: string;
  /** capability_ids the customer has enabled (subset of offering capabilities) */
  enabled_capabilities?: string[];
  /** Operator-only per-capability adjustments keyed by capability_id */
  capability_overrides?: Record<string, any>;
  /** Operator-supplied values for operator-input bindings. Outer key: component_name. Inner key: cfn_param_key. Value: string. */
  operator_inputs?: Record<string, Record<string, string>>;
  /** Lifecycle status of this configuration */
  status?: ConfigurationStatusType;
  /** ISO-8601 timestamp of initial subscription */
  subscribed_at: string;
  /** ISO-8601 timestamp of last reconciler sync */
  last_synced_at?: string;
}

/**
 * Portfolio definition grouping products for SC deployment
 */
export interface PortfolioDefinition {
  id: string;
  name: string;
  display_name: string;
  description: string;
  sc_portfolio_id: string;
  regional_portfolio_ids: Record<string, string>;
  created_at: string;
  updated_at: string;
}

/**
 * M2M pipeline credential for service access
 */
export interface PipelineCredential {
  client_id: string;
  service_id: string;
  customer_id: string;
  label: string;
  scopes: string[];
  status: PipelineCredentialStatusType;
  secret_arn: string;
  created_at: string;
  created_by: string;
  revoked_at: string;
}

/**
 * List of pipeline credentials
 */
export interface PipelineCredentialList {
  credentials: PipelineCredential[];
  total_count: number;
}

// ============================================================================
// EventBridge Rules Manager Models
// ============================================================================

/**
 * ITSM (Freshservice ticket) delivery channel
 */
export interface ItsmChannel {
  /** Ticket priority (low|medium|high|urgent); omitted means the enrichment severity decides */
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  /** Freshservice agent group id to route the ticket to; overrides the customer default group when set */
  agent_group_id?: number;
  /** Freshservice agent id to assign the ticket to; overrides the customer default assignee when set */
  responder_id?: number;
  /** Optional channel-level format prompt */
  format_prompt_id?: string;
  /** Per-key content overrides {subject|description: value}. A value starting with $ is a JSONPath into the source event ($.enrichment.* reads the enrichment); any other value is fixed text. A filled key wins over the AI output; leave a key out to use AI. With summarize off both keys are required. */
  field_mappings?: Record<string, string>;
}

/**
 * A single notification delivery channel (email or sns)
 */
export interface NotificationTarget {
  /** Delivery channel type */
  channel: 'email' | 'sns';
  /** Recipients (email addresses or SNS topic ARNs) */
  to: string[];
  /** Optional channel-level format prompt */
  format_prompt_id?: string;
  /** Per-key content overrides; for email {subject|body: value}. A value starting with $ is a JSONPath into the source event ($.enrichment.* reads the enrichment); any other value is fixed text. A filled key wins over the AI output; leave a key out to use AI. With summarize off an email target requires both keys. */
  field_mappings?: Record<string, string>;
}

/**
 * Automation actor (agent prompt) on the incident
 */
export interface AutomationChannel {
  /** Prompt ID for the automation agent */
  prompt_id: string;
  /** Agent that runs the automation prompt: an active batch agent, e.g. 'automation' */
  agent_id: string;
}

/**
 * Automation actor a rule save carries; omit agent_id for the current automation agent
 */
export interface AutomationChannelRequest {
  /** Prompt ID for the automation agent */
  prompt_id: string;
  /** Active batch agent that runs the prompt; omitted, the current automation agent */
  agent_id?: string;
}

/**
 * Declares when an inbound event means the incident has recovered
 */
export interface ResolveSignal {
  /** Field path into event_data — plain dot-path or $.-JSONPath, e.g. '$.detail.message.NewStateValue' */
  field_path: string;
  /** event_data values that mean recovered, e.g. ['OK'] */
  values: string[];
  /** Resolution text set on the ITSM ticket when auto-resolving; a default is generated if omitted */
  resolution?: string;
  /** ITSM status name the ticket is driven to when auto-resolving — a tenant status label (e.g. 'Alert resolved') or one of open/pending/resolved/closed. Omitted means 'resolved'. */
  ticket_status?: string;
}

/**
 * Request to create a new EventBridge rule
 */
export interface RuleCreate {
  /** Customer ID owning this rule */
  customer_id: string;
  /** Rule classification type */
  rule_type: RuleTypeType;
  /** Rule name (alphanumeric, underscores, hyphens) */
  name: string;
  /** Rule description */
  description?: string;
  /** Trigger type - event-based or schedule-based */
  trigger_type?: 'event' | 'schedule';
  /** EventBridge event pattern (required if trigger_type='event') */
  event_pattern?: Record<string, any>;
  /** EventBridge schedule expression (cron or rate) (required if trigger_type='schedule') */
  schedule_expression?: string;
  /** Rule-level enrichment prompt (source-aware understanding) */
  enrichment_prompt_id?: string;
  /** Run AI enrichment on the event. When False, delivery uses the raw event via field mappings or format prompts (D12). */
  summarize?: boolean;
  /** ITSM (Freshservice ticket) delivery channel */
  itsm?: ItsmChannel;
  /** Per-channel notification targets (email, sns) */
  notification_targets?: NotificationTarget[];
  /** Automation actor (agent prompt) */
  automation?: AutomationChannelRequest;
  /** Whether rule is enabled */
  enabled?: boolean;
  /** Example events for testing rule pattern */
  event_examples?: Record<string, any>[];
  /** Strategy for OpsItem creation: track (dedup by rule), always_new (fresh each time), fingerprint (dedup by chosen event fields) */
  opsitem_strategy?: OpsItemStrategyType;
  /** JSONPath fields composing the dedup fingerprint; required (>=1) when opsitem_strategy='fingerprint', must be empty otherwise */
  dedup_field_paths?: string[];
  /** Optional recovery signal: when an inbound event's field_path value matches, resolve the incident and move the ITSM ticket to ticket_status (default 'resolved') instead of opening */
  resolve_signal?: ResolveSignal;
}

/**
 * Deployment state of a rule at a specific location
 */
export interface RuleDeployment {
  /** Deployment location type */
  location: RuleDeploymentLocationType;
  /** Target AWS account ID (None for opspilot) */
  account_id?: string;
  /** EventBridge bus name at the target */
  bus_name?: string;
  /** ARN of the EventBridge rule once created */
  rule_arn?: string;
  /** Current sync status */
  sync_status?: RuleSyncStatusType;
  /** Last successful sync timestamp (ISO 8601) */
  last_synced_at?: string;
  /** Last error message if sync_status is failed */
  error?: string;
}

/**
 * Rule owner identity (ADR-0047)
 */
export interface RuleOwner {
  type: 'user' | 'agent' | 'system';
  sub?: string;
  token_source?: string;
  email?: string;
}

/**
 * EventBridge rule details
 */
export interface EventRule {
  /** Rule name (serves as ID) */
  rule_id: string;
  /** Rule classification type */
  rule_type: RuleTypeType;
  /** Rule owner identity (ADR-0047) */
  owner?: RuleOwner;
  /** Rule name */
  name: string;
  /** Rule description */
  description: string;
  /** Trigger type - event-based or schedule-based */
  trigger_type?: 'event' | 'schedule';
  /** EventBridge event pattern (present if trigger_type='event') */
  event_pattern?: Record<string, any>;
  /** EventBridge schedule expression (present if trigger_type='schedule') */
  schedule_expression?: string;
  /** Rule-level enrichment prompt */
  enrichment_prompt_id?: string;
  /** Whether AI enrichment runs on the event (D12) */
  summarize?: boolean;
  /** ITSM (Freshservice ticket) delivery channel */
  itsm?: ItsmChannel;
  /** Per-channel notification targets (email, sns) */
  notification_targets?: NotificationTarget[];
  /** Automation actor (agent prompt) */
  automation?: AutomationChannel;
  /** Recovery signal: when an inbound event's field_path value matches, resolve the incident and move the ITSM ticket to ticket_status (default 'resolved') instead of opening */
  resolve_signal?: ResolveSignal;
  /** Rule status */
  status: 'ENABLED' | 'DISABLED';
  /** Creation timestamp (ISO 8601) */
  created_at: string;
  /** Desired lifecycle status */
  desired_status?: 'active' | 'deleted';
  /** Deployment status per location */
  deployments?: RuleDeployment[];
  /** Example events for testing rule pattern */
  event_examples?: Record<string, any>[];
  /** Strategy for OpsItem creation */
  opsitem_strategy?: OpsItemStrategyType;
  /** JSONPath fields composing the dedup fingerprint (fingerprint strategy only) */
  dedup_field_paths?: string[];
}

/**
 * Lightweight rule list item
 */
export interface EventRuleListItem {
  /** Rule name (serves as ID) */
  rule_id: string;
  /** Rule classification type */
  rule_type: RuleTypeType;
  /** Rule name */
  name: string;
  /** Rule description */
  description: string;
  /** Trigger type */
  trigger_type?: 'event' | 'schedule';
  /** Whether rule has ITSM integration configured */
  has_itsm?: boolean;
  /** Whether rule has automation configured */
  has_automation?: boolean;
  /** Rule status */
  status: 'ENABLED' | 'DISABLED';
  /** Creation timestamp (ISO 8601) */
  created_at: string;
  /** Desired lifecycle status */
  desired_status?: 'active' | 'deleted';
  /** Aggregate sync status */
  sync_status?: RuleSyncStatusType;
  /** Strategy for OpsItem creation */
  opsitem_strategy?: OpsItemStrategyType;
}

/**
 * Request to test an event pattern
 */
export interface PatternTestRequest {
  /** EventBridge event pattern */
  event_pattern: Record<string, any>;
  /** Test event to match against pattern */
  test_event: Record<string, any>;
}

/**
 * Result of pattern test
 */
export interface PatternTestResponse {
  /** Whether event matches pattern */
  matches: boolean;
}

/**
 * Per-channel rendered output from a rule preview (Contract C-03)
 */
export interface PreviewChannelResult {
  /** Channel type: itsm | email | sns */
  channel: string;
  /** Rendered channel payload (HTML string for ITSM, plaintext for email, dict for SNS) */
  rendered_output: any;
  /** Per output key, the tier that produced it: mapping | prompt | template | static. Empty when the channel could not be produced. */
  sources: Record<string, 'mapping' | 'prompt' | 'template' | 'static'>;
}

/**
 * Request to preview rule output against a sample event (Contract C-03)
 */
export interface PreviewRuleOutputRequest {
  /** Customer ID owning the rule */
  customer_id: string;
  /** Load rule config from DB by rule_id */
  rule_id?: string;
  /** Inline C-02 rule config (used when rule_id is absent) */
  rule?: Record<string, any>;
  /** Raw source event to run through the rule */
  sample_event: Record<string, any>;
}

/**
 * Preview of what a rule produces against a sample event — no side effects (Contract C-03)
 */
export interface PreviewRuleOutputResponse {
  /** Neutral structured understanding {title, summary, severity}, or null if enrichment is disabled */
  enrichment?: Record<string, any>;
  /** Per-channel rendered outputs */
  channels: PreviewChannelResult[];
  /** Non-fatal warnings (e.g. prompt not seeded, channel skipped) */
  warnings: string[];
}

/**
 * Request to suggest channel field_mappings from a sample event
 */
export interface SuggestFieldMappingsRequest {
  /** Customer context for authorization */
  customer_id: string;
  /** Raw source event (full EventBridge envelope) */
  sample_event: Record<string, any>;
  /** Channel content keys to suggest mappings for */
  fields: string[];
}

/**
 * Suggested JSONPath field_mappings (full-envelope $.detail.X paths)
 */
export interface SuggestFieldMappingsResponse {
  /** Field name → JSONPath expression */
  mappings?: Record<string, string>;
  /** Fields without a usable suggestion */
  warnings: string[];
}

/**
 * The raw source event behind a rule's newest action log item
 */
export interface RuleSampleEvent {
  /** Rule the event was matched by */
  rule_id: string;
  /** Action log item the event is archived on */
  opsitem_id: string;
  /** Full EventBridge envelope as the rule received it */
  event: Record<string, any>;
}

/**
 * Result of rendering a transform template against a sample event
 */
export interface TransformTestResponse {
  /** Whether transformation succeeded */
  success: boolean;
  /** Successfully extracted field values */
  extracted_fields?: Record<string, any>;
  /** JSONPath evaluation errors */
  errors: string[];
  /** Complete transformed event as it would be sent to target Lambda */
  transformed_output?: Record<string, any>;
}

/**
 * Rule template details
 */
export interface TemplateResponse {
  template_id: string;
  owner: string;
  customer_id?: string;
  name: string;
  description: string;
  category: string;
  tags: string[];
  rule_type: string;
  trigger_type: string;
  event_pattern?: Record<string, any>;
  schedule_expression?: string;
  itsm_config?: Record<string, any>;
  enrichment_prompt_id?: string;
  automation_prompt_id?: string;
  automation_agent_id?: string;
  notifications: Record<string, any>[];
  field_mappings?: Record<string, string>;
  opsitem_strategy: OpsItemStrategyType;
  created_at: string;
  updated_at: string;
}

/**
 * Lightweight rule template list item
 */
export interface TemplateListItem {
  template_id: string;
  owner: string;
  customer_id?: string;
  name: string;
  description: string;
  category: string;
  tags: string[];
  rule_type: string;
  trigger_type: string;
  created_at: string;
}

/**
 * A rule whose automation runs on the agent (PS-UC-18)
 */
export interface RuleNamingAgent {
  /** Customer the rule belongs to */
  customer_id: string;
  /** That customer's name */
  customer_name: string;
  /** Rule name (serves as ID) */
  rule_name: string;
  /** Whether the rule is enabled */
  enabled: boolean;
  /** The automation prompt the agent runs for this rule */
  prompt_id: string;
}

/**
 * A rule template whose automation runs on the agent (PS-UC-18)
 */
export interface TemplateNamingAgent {
  /** Template ID */
  template_id: string;
  /** Global, or owned by one customer */
  owner: 'global' | 'customer';
  /** Owning customer, for a customer template */
  customer_id?: string;
  /** Template name */
  name: string;
}

/**
 * The rules and templates that still name an agent, across every customer (PS-UC-18)
 */
export interface AgentReferences {
  rules?: RuleNamingAgent[];
  templates?: TemplateNamingAgent[];
}

/**
 * One hop in the event journey across the 3-tier architecture
 */
export interface TraceStage {
  /** Stage identifier (e.g., 'customer_emit', 'operations_receive') */
  stage: string;
  /** Human-readable stage name */
  label: string;
  /** AWS account ID for this stage */
  account: string;
  /** Human-readable account label (e.g., 'Customer', 'Operations') */
  account_label: string;
  /** AWS region */
  region: string;
  /** When the event was seen at this stage (ISO 8601) */
  timestamp?: string;
  /** Milliseconds since origin event */
  delta_ms?: number;
  /** Status at this stage */
  status: TraceStatusType;
  /** How status was determined */
  evidence: string;
}

/**
 * End-to-end trace of an event across the 3-tier architecture
 */
export interface EventTrace {
  /** Generated trace identifier */
  trace_id: string;
  /** Source event ID */
  event_id: string;
  /** The source event being traced */
  origin_event: LiveEvent;
  /** Ordered trace stages */
  stages: TraceStage[];
  /** Overall trace health */
  overall_status: TraceStatusType;
  /** Event path: 'direct' (PATH 1) or 'forwarder' (PATH 2) */
  path: string;
  /** X-Ray trace ID if available */
  xray_trace_id?: string;
  /** Availability of data sources */
  data_sources?: Record<string, boolean>;
}

/**
 * Request params for the events:ListRules action.
 */
export interface ListRulesRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params for events:ListRulesNamingAgent: the agent whose rules and templates to list.
 */
export interface ListRulesNamingAgentRequest {
  /** Agent ID, e.g. 'automation' */
  agent_id: string;
}

/**
 * Request params for events:ListEventDatasets.
 */
export interface ListEventDatasetsRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params identifying one Event Dataset (events:GetEventDataset).
 */
export interface GetEventDatasetRequest {
  /** Customer ID */
  customer_id: string;
  /** Dataset name, unique for the customer */
  name: string;
}

/**
 * Request params identifying one Event Dataset to delete (events:DeleteEventDataset).
 */
export interface DeleteEventDatasetRequest {
  /** Customer ID */
  customer_id: string;
  /** Dataset name, unique for the customer */
  name: string;
}

/**
 * Request params identifying one Event Dataset whose tables are rebuilt (events:RebuildEventDataset).
 */
export interface RebuildEventDatasetRequest {
  /** Customer ID */
  customer_id: string;
  /** Dataset name, unique for the customer */
  name: string;
}

/**
 * Request params identifying one Event Dataset whose status is read (events:GetEventDatasetStatus).
 */
export interface GetEventDatasetStatusRequest {
  /** Customer ID */
  customer_id: string;
  /** Dataset name, unique for the customer */
  name: string;
}

/**
 * Request params for the events that did not fit one Event Dataset (events:ListEventDatasetMisfits).
 */
export interface ListEventDatasetMisfitsRequest {
  /** Customer ID */
  customer_id: string;
  /** Dataset name, unique for the customer */
  name: string;
  /** Only the events that did not fit this column; every column when omitted */
  column?: string;
  /** Only misfits, or only untranslated notes of kept rows; both when omitted */
  kind?: 'misfit' | 'untranslated';
  /** The most events returned, newest first */
  limit?: number;
}

/**
 * Request params for the rows a draft Event Dataset would give (events:PreviewEventDataset).
 */
export interface PreviewEventDatasetRequest {
  /** Customer ID */
  customer_id: string;
  /** The definition to preview; nothing is saved */
  draft: EventDataset;
  /** An event pasted by the operator, previewed beside the last 24 hours of raw events */
  sample?: Record<string, any>;
  /** The most rows returned per read, newest first */
  limit?: number;
}

/**
 * Rows whose column matches the filter: `in` one of the values, `contains` a text value, or a `range`.
 */
export interface EventDatasetFilter {
  /** A column of the dataset; not a list or json column */
  column: string;
  /** in: the column holds one of the values (one value is an equality); contains: a text column holds the one value, case-sensitive; range: a number or timestamp column from min to max */
  op?: 'in' | 'contains' | 'range';
  /** Values written as text and read as the column's type: text, a number such as 70, true or false, or an ISO 8601 time with a zone; none for range */
  values?: string[];
  /** range only: the lowest value, inclusive */
  min?: string;
  /** range only: the value the range ends before, exclusive */
  max?: string;
}

/**
 * Request params for the one dataset read (events:QueryEventDataset, EM-UC-36 step 3).

The read is built from the stored definition; no parameter takes query text.
 */
export interface QueryEventDatasetRequest {
  /** Customer ID */
  customer_id: string;
  /** Dataset name, unique for the customer */
  name: string;
  /** history: every row kept, needs since and until; current: the newest row per key */
  view: 'history' | 'current';
  /** Start of the time span, ISO 8601 with a zone; required for history */
  since?: string;
  /** End of the time span, exclusive, ISO 8601 with a zone; required for history */
  until?: string;
  /** Every filter must hold for a row */
  filters?: EventDatasetFilter[];
  /** Count instead of listing: 1 to 3 text, number, boolean or timestamp columns. Returns one row per group with the group columns and its count, largest count first, plus rows_matched over every group. Use it for counts, top N and 'most frequent' questions over a span, which rows cannot answer past the row limit; omit it to read rows. Takes no columns, order_by or descending=false; limit counts groups */
  group_by?: string[];
  /** The columns to return; every column when omitted */
  columns?: string[];
  /** The column to order by; event_time when omitted */
  order_by?: string;
  /** Order newest or largest first; a group_by read is always largest first */
  descending?: boolean;
  /** The most rows, or groups with group_by, returned */
  limit?: number;
  /** The next_token of the previous page of the same read */
  next_token?: string;
  /** Return only rows_matched for the filters and span, no rows; takes no group_by, columns, order_by, descending=false or next_token */
  count_only?: boolean;
}

/**
 * Request params for events:ListCustomerEventDatasetTemplates: the customer's own and the global templates.
 */
export interface ListCustomerEventDatasetTemplatesRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params identifying one Event Dataset template (events:GetEventDatasetTemplate).

Authorized on the customer; a global template is read through any customer, as each one sees them.
 */
export interface GetEventDatasetTemplateRequest {
  /** Customer ID the template is read for */
  customer_id: string;
  /** Template ID */
  template_id: string;
  /** 'global' for a template every customer shares, 'customer' for the customer's own */
  owner: 'global' | 'customer';
}

/**
 * Request params for events:CreateGlobalEventDatasetTemplate: the template itself, shared by every customer.
 */
export interface CreateGlobalEventDatasetTemplateRequest {
  /** Template name, unique within its scope */
  name: string;
  description?: string;
  category?: string;
  tags?: string[];
  definition: EventDatasetDefinition;
}

/**
 * Request params for events:CreateCustomerEventDatasetTemplate: the template and the customer that owns it.
 */
export interface CreateCustomerEventDatasetTemplateRequest {
  /** Template name, unique within its scope */
  name: string;
  description?: string;
  category?: string;
  tags?: string[];
  definition: EventDatasetDefinition;
  /** Customer ID that owns the template */
  customer_id: string;
}

/**
 * Request params for updating a CUSTOMER-owned template (events:UpdateEventDatasetTemplate).

No `owner` field: the action is authorized on one Customer, so it only writes that customer's own
template. A global template is updated through events:UpdateGlobalEventDatasetTemplate.
 */
export interface UpdateEventDatasetTemplateRequest {
  name?: string;
  description?: string;
  category?: string;
  tags?: string[];
  definition?: EventDatasetDefinition;
  /** Customer ID that owns the template */
  customer_id: string;
  /** Template ID */
  template_id: string;
}

/**
 * Request params for updating a GLOBAL template (events:UpdateGlobalEventDatasetTemplate).
 */
export interface UpdateGlobalEventDatasetTemplateRequest {
  name?: string;
  description?: string;
  category?: string;
  tags?: string[];
  definition?: EventDatasetDefinition;
  /** Template ID */
  template_id: string;
}

/**
 * Request params identifying one CUSTOMER-owned template to delete (events:DeleteEventDatasetTemplate).
 */
export interface DeleteEventDatasetTemplateRequest {
  /** Customer ID that owns the template */
  customer_id: string;
  /** Template ID */
  template_id: string;
}

/**
 * Request params identifying one GLOBAL template to delete (events:DeleteGlobalEventDatasetTemplate).
 */
export interface DeleteGlobalEventDatasetTemplateRequest {
  /** Template ID */
  template_id: string;
}

/**
 * Request params identifying one rule to read (events:GetRule).
 */
export interface GetRuleRequest {
  /** Customer ID */
  customer_id: string;
  /** Rule ID */
  rule_id: string;
}

/**
 * Request params for a partial rule update (events:UpdateRule).

customer_id and rule_id identify the rule; every other field is an optional
mutable attribute that RulesService.update_rule actually applies. The handler
forwards whichever of these the client sent, so all are Optional and unset
fields are left unchanged. name and rule_type are deliberately absent — they
are set only at create time and update_rule ignores them (advertising them
would be a silent no-op, esp. via the agent tool surface).
 */
export interface UpdateRuleRequest {
  /** Customer ID */
  customer_id: string;
  /** Rule ID */
  rule_id: string;
  /** Rule description */
  description?: string;
  /** How the rule fires: 'event' (pattern-matched) or 'schedule' (cron/rate) */
  trigger_type?: 'event' | 'schedule';
  /** EventBridge event pattern (required when trigger_type='event') */
  event_pattern?: Record<string, any>;
  /** cron(...) or rate(...) expression (required when trigger_type='schedule') */
  schedule_expression?: string;
  /** Rule-level enrichment prompt (source-aware understanding) */
  enrichment_prompt_id?: string;
  /** Run AI enrichment on the event. When False, delivery uses the raw event via field mappings or format prompts (D12). */
  summarize?: boolean;
  /** ITSM (Freshservice ticket) delivery channel */
  itsm?: ItsmChannel;
  /** Per-channel notification targets (email, sns) */
  notification_targets?: NotificationTarget[];
  /** Automation actor (agent prompt); omit agent_id for the current automation agent */
  automation?: AutomationChannelRequest;
  /** Whether rule is enabled */
  enabled?: boolean;
  /** Example events for testing rule pattern */
  event_examples?: Record<string, any>[];
  /** Strategy for OpsItem creation: track (dedup by rule), always_new (fresh each time), fingerprint (dedup by chosen event fields) */
  opsitem_strategy?: OpsItemStrategyType;
  /** JSONPath fields composing the dedup fingerprint; required (>=1) when opsitem_strategy='fingerprint', must be empty otherwise */
  dedup_field_paths?: string[];
  /** Recovery signal: when an inbound event's field_path value matches, resolve the incident and move the ITSM ticket to ticket_status (default 'resolved') instead of opening */
  resolve_signal?: ResolveSignal;
}

/**
 * Request params for the events:TestPattern action.

The handler forwards every param but customer_id into `PatternTestRequest`
(common.models), which reads `event_pattern` + `test_event`.
 */
export interface TestPatternRequest {
  /** Customer ID */
  customer_id: string;
  /** EventBridge event pattern JSON */
  event_pattern: Record<string, any>;
  /** Sample event JSON to test against */
  test_event: Record<string, any>;
}

/**
 * Request params for the events:TestTransform action.

The handler forwards every param but customer_id into `TransformTestRequest`
(common.models), which reads `field_mappings` + `test_event` — a transformation
here is a set of JSONPath field mappings, not a template string.
 */
export interface TestTransformRequest {
  /** Customer ID */
  customer_id: string;
  /** JSONPath mappings to test: {output_field: jsonpath_expression} */
  field_mappings: Record<string, string>;
  /** Sample event JSON to transform */
  test_event: Record<string, any>;
}

/**
 * Request params for the events:GetActionLog action.
 */
export interface GetActionLogRequest {
  /** Customer ID */
  customer_id: string;
  /** Filter by rule type */
  rule_type?: string;
  /** Filter by status */
  status?: string;
  /** Max results (default 50) */
  max_results?: number;
  /** Pagination token */
  next_token?: string;
  /** Return only rendered report entries */
  reports_only?: boolean;
}

/**
 * Request params identifying one action log item (events:GetActionLogItem).
 */
export interface GetActionLogItemRequest {
  /** Customer ID */
  customer_id: string;
  /** Action log item id */
  opsitem_id: string;
}

/**
 * Request params for the events:GetEvents action.
 */
export interface GetEventsRequest {
  customer_id: string;
  timeRange?: string;
  startTime?: string;
  endTime?: string;
  since?: string;
  limit?: number;
  source?: string;
  search?: string;
  detailType?: string;
  region?: string;
  account?: string;
  excludeSources?: string;
  excludeDetailTypes?: string;
  excludeRegions?: string;
  excludeAccounts?: string;
}

/**
 * Request params for the events:GetEventTrace action.
 */
export interface GetEventTraceRequest {
  customer_id: string;
  event_id: string;
  timestamp: string;
}

/**
 * Request params for the events:ListCustomerTemplates action.
 */
export interface ListCustomerTemplatesRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params identifying one template to read (events:GetTemplate).
 */
export interface GetTemplateRequest {
  /** Customer ID (required when owner='customer') */
  customer_id: string;
  /** Template ID */
  template_id: string;
  /** Template owner (global or customer) */
  owner?: 'global' | 'customer';
}

/**
 * Request params for the events:CreateGlobalTemplate action.

The template fields themselves: the handler forwards the params into `TemplateCreate`, which is
extra='forbid', so the request is that model and nothing else.
 */
export interface CreateGlobalTemplateRequest {
  name: string;
  description?: string;
  category?: string;
  tags?: string[];
  rule_type?: string;
  trigger_type?: string;
  event_pattern?: Record<string, any>;
  schedule_expression?: string;
  itsm_config?: Record<string, any>;
  enrichment_prompt_id?: string;
  automation_prompt_id?: string;
  automation_agent_id?: string;
  notifications?: Record<string, any>[];
  field_mappings?: Record<string, string>;
  opsitem_strategy?: OpsItemStrategyType;
}

/**
 * Request params for the events:CreateCustomerTemplate action.

Subclasses `TemplateCreate` rather than restating it: the handler strips
customer_id and forwards the rest into `TemplateCreate`, which is
extra='forbid', so any field it gains or loses must appear here or every call
becomes a ValidationError. Inheriting binds the two; the fields below are
re-declared only to carry the agent-facing descriptions.
 */
export interface CreateCustomerTemplateRequest {
  /** Template name */
  name: string;
  /** Template description */
  description?: string;
  /** Template category: Security, Cost, Compute, Storage, Governance, Monitoring, Database or Custom */
  category?: string;
  /** Free-form tags */
  tags?: string[];
  /** Rule classification: 'alert' or 'automation' */
  rule_type?: string;
  /** How rules from this template fire: 'event' or 'schedule' */
  trigger_type?: string;
  /** EventBridge event pattern (for trigger_type='event') */
  event_pattern?: Record<string, any>;
  /** cron(...) or rate(...) expression (for trigger_type='schedule') */
  schedule_expression?: string;
  /** ITSM (Freshservice ticket) delivery config: {priority, agent_group_id, format_prompt_id} */
  itsm_config?: Record<string, any>;
  /** Rule-level enrichment prompt (source-aware understanding) */
  enrichment_prompt_id?: string;
  /** Prompt ID for the automation agent */
  automation_prompt_id?: string;
  /** Agent that runs automation_prompt_id: an active batch agent, e.g. 'automation'; required with it */
  automation_agent_id?: string;
  /** Notification targets: [{type: 'email'|'sns', to: [...]}] */
  notifications?: Record<string, any>[];
  /** Per-key content overrides {output_field: JSONPath or fixed text}; a filled key wins over the AI output */
  field_mappings?: Record<string, string>;
  /** Strategy for OpsItem creation: track (dedup by rule), always_new (fresh each time), fingerprint (dedup by chosen event fields) */
  opsitem_strategy?: OpsItemStrategyType;
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params for updating a CUSTOMER-owned template (events:UpdateTemplate).

There is deliberately no `owner` field: this action is authorized against one
Customer, so it can only ever write that customer's own template. Global
templates are shared across every customer and are updated through
events:UpdateGlobalTemplate, which is authorized globally.
 */
export interface UpdateTemplateRequest {
  /** Template name */
  name?: string;
  /** Template description */
  description?: string;
  /** Template category: Security, Cost, Compute, Storage, Governance, Monitoring, Database or Custom */
  category?: string;
  /** Free-form tags */
  tags?: string[];
  /** Rule classification: 'alert' or 'automation' */
  rule_type?: string;
  /** How rules from this template fire: 'event' or 'schedule' */
  trigger_type?: string;
  /** EventBridge event pattern (for trigger_type='event') */
  event_pattern?: Record<string, any>;
  /** cron(...) or rate(...) expression (for trigger_type='schedule') */
  schedule_expression?: string;
  /** ITSM (Freshservice ticket) delivery config: {priority, agent_group_id, format_prompt_id} */
  itsm_config?: Record<string, any>;
  /** Rule-level enrichment prompt (source-aware understanding) */
  enrichment_prompt_id?: string;
  /** Prompt ID for the automation agent */
  automation_prompt_id?: string;
  /** Agent that runs automation_prompt_id: an active batch agent, e.g. 'automation'; required with it */
  automation_agent_id?: string;
  /** Notification targets: [{type: 'email'|'sns', to: [...]}] */
  notifications?: Record<string, any>[];
  /** Per-key content overrides {output_field: JSONPath or fixed text}; a filled key wins over the AI output */
  field_mappings?: Record<string, string>;
  /** Strategy for OpsItem creation: track (dedup by rule), always_new (fresh each time), fingerprint (dedup by chosen event fields) */
  opsitem_strategy?: OpsItemStrategyType;
  /** Customer ID that owns the template */
  customer_id: string;
  /** Template ID */
  template_id: string;
}

// ============================================================================
// Action Log Models
// ============================================================================

/**
 * An action log entry from OpsItems
 */
export interface ActionLogEntry {
  opsitem_id: string;
  title: string;
  source?: string;
  detail_type?: string;
  status: string;
  severity: string;
  rule_name?: string;
  rule_type?: string;
  created_at: string;
  updated_at?: string;
  automation_result?: Record<string, any>;
  report_ref?: string;
  report_origin?: string;
}

/**
 * Response containing action log entries
 */
export interface ActionLogResponse {
  items: ActionLogEntry[];
  next_token?: string;
}

/**
 * A saved Event Dataset definition with its timestamps
 */
export interface EventDatasetRecord {
  /** Lowercase letters, digits and underscore, starting with a letter, at most 64 */
  name: string;
  /** One to four inputs, each an event format feeding the same columns, identified by position; an event matching more than one does not fit */
  inputs: DatasetInput[];
  /** Dotted path from the event root to the list whose elements each become a row, such as `detail.findings`; omitted means one event is one row */
  row_path?: string;
  /** The operator's columns; the standard columns come first and are not listed here */
  columns: DatasetColumn[];
  /** Whether an event without a resource does not fit; False makes such an event a row with an empty resource, for events about a whole account. An optional resource cannot be a key field */
  resource_required?: boolean;
  /** Columns identifying the thing a row is about; each must be required */
  key_fields: string[];
  /** Column deciding the newest row for a key; omitted means event_time */
  ordering_field?: string;
  /** Keep a current state per key beside the history */
  keep_current_state: boolean;
  /** Days of history kept; at most the raw archive's retention */
  retention_days: number;
  /** Only events in v1 */
  source?: 'events';
  customer_id: string;
  /** When the dataset was created, ISO 8601 UTC */
  created_at: string;
  /** When the definition last changed, ISO 8601 UTC */
  updated_at: string;
  /** active, or deleting until the reconciler has dropped the tables and removed the dataset */
  status?: 'active' | 'deleting';
  /** When an admin last asked for the tables to be rebuilt, UTC; None when never */
  rebuild_requested_at?: string;
}

/**
 * The Event Dataset a delete removed
 */
export interface EventDatasetDeleted {
  customer_id: string;
  name: string;
}

/**
 * A reusable Event Dataset definition, global or one customer's
 */
export interface EventDatasetTemplate {
  /** Template name, unique within its scope */
  name: string;
  description?: string;
  category?: string;
  tags?: string[];
  definition: EventDatasetDefinition;
  template_id: string;
  owner: TemplateOwnerType;
  /** The owning customer; None for a global template */
  customer_id?: string;
  /** When the template was created, ISO 8601 UTC */
  created_at: string;
  /** When the template last changed, ISO 8601 UTC */
  updated_at: string;
}

/**
 * The Event Dataset template a delete removed
 */
export interface EventDatasetTemplateDeleted {
  template_id: string;
  owner: TemplateOwnerType;
  /** The owning customer; None for a global template */
  customer_id?: string;
}

/**
 * How many matching events of one input did not fit one column, and why
 */
export interface MisfitCount {
  /** The input, by position, the events were read with; None for counts recorded before inputs were counted */
  input?: number;
  /** The column the value did not fit, row_path, or inputs for an event matching more than one */
  column: string;
  /** Why it did not fit, such as missing or not a number */
  reason: string;
  count: number;
}

/**
 * One value a translation does not cover, and how many kept rows hold it
 */
export interface UntranslatedValue {
  /** The value as it came, cut to 64 characters */
  value: string;
  count: number;
}

/**
 * Kept rows of one input whose column held a value its translation does not cover
 */
export interface UntranslatedCount {
  /** The input, by position, the rows were read with */
  input: number;
  column: string;
  /** Every untranslated value of the column, not only those listed */
  count: number;
  /** At most 20 values, the most frequent first */
  values: UntranslatedValue[];
}

/**
 * The longest retention an Event Dataset may keep: the raw archive's
 */
export interface EventDatasetRetentionCeiling {
  customer_id: string;
  /** Days the raw archive keeps; None when raw never expires, so any retention fits */
  retention_days: number;
}

/**
 * How far an Event Dataset has got and how many events did not fit it
 */
export interface EventDatasetStatus {
  customer_id: string;
  name: string;
  /** current, backfilling, behind, failing or deleting */
  state: 'current' | 'backfilling' | 'behind' | 'failing' | 'deleting';
  /** Why the dataset is failing; None in every other state */
  reason?: string;
  /** Newest event time in the history, UTC */
  newest_event?: string;
  /** First day the backfilled history holds */
  earliest_history?: string;
  /** Last day the backfilled history holds */
  backfilled_through?: string;
  /** When the last curation of today started */
  curated_through?: string;
  /** Newest raw event the pattern matches, read only when the last curation is stale, UTC */
  newest_matching_in_raw?: string;
  /** When raw was read for newest_matching_in_raw; None when raw was not read */
  checked_at?: string;
  /** Set on a current dataset no matching event has reached for a while: its newest event */
  no_matching_since?: string;
  /** Events that did not fit, by column and reason */
  misfit_counts: MisfitCount[];
  /** Rows kept with a value their translation does not cover, by input and column; not misfits */
  untranslated_counts?: UntranslatedCount[];
}

/**
 * One problem of one event row that did not fit an Event Dataset
 */
export interface EventDatasetMisfit {
  event_id: string;
  row_position: number;
  column: string;
  reason: string;
  event_time: string;
  /** The input, by position, the event was read with: the first whose pattern it matches */
  input: number;
  /** misfit, kept out of history; or untranslated, a note on a row that was kept */
  kind: 'misfit' | 'untranslated';
  /** An untranslated note's value as it came, cut to 64 characters; None for a misfit */
  value?: string;
}

/**
 * Why a previewed row would not fit an Event Dataset
 */
export interface EventDatasetPreviewProblem {
  column: string;
  reason: string;
}

/**
 * A value a previewed row keeps that its translation does not cover
 */
export interface EventDatasetPreviewNote {
  column: string;
  /** The value as it came, cut to 64 characters */
  value: string;
}

/**
 * One row a draft Event Dataset would give
 */
export interface EventDatasetPreviewRow {
  /** Position within the row path's list, 0 without one */
  row_position: number;
  /** The input, by position, the row was read with: the first whose pattern it matches */
  input: number;
  /** Every column's value as Athena gives it as text; a list column as JSON; None when empty */
  values: Record<string, string | null>;
  /** Empty when the row fits */
  problems: EventDatasetPreviewProblem[];
  /** Values the row keeps that their translation does not cover; never a misfit */
  notes: EventDatasetPreviewNote[];
}

/**
 * The rows one preview read gave, and how many events it matched
 */
export interface EventDatasetPreviewRows {
  /** Matching events read, of which at most the limit's rows are shown */
  events_read: number;
  rows: EventDatasetPreviewRow[];
}

/**
 * The rows a draft Event Dataset would give from recent events and a pasted sample
 */
export interface EventDatasetPreview {
  customer_id: string;
  name: string;
  /** Start of the recent window read from the raw archive, UTC */
  since: string;
  /** End of the recent window, UTC */
  until: string;
  recent: EventDatasetPreviewRows;
  /** The pasted event's rows; None without one */
  sample?: EventDatasetPreviewRows;
}

/**
 * The rows one Event Dataset read gave, with the dataset's freshness
 */
export interface EventDatasetRows {
  customer_id: string;
  name: string;
  /** history, every row kept, or current, the newest row per key */
  view: 'history' | 'current';
  /** Start of the span read, UTC, never before the retention window; None for all of current */
  since?: string;
  /** Says the span was started at the retention window's start; None when read as asked */
  span_note?: string;
  /** End of the time span read, exclusive, UTC */
  until?: string;
  /** The columns of every row, in order */
  columns: string[];
  /** Each row's values as Athena gives them as text; a list column as JSON; None when empty */
  rows: Record<string, string | null>[];
  /** With group_by, the rows matched over every group, not only those returned; with count_only, the rows matched; None for rows */
  rows_matched?: number;
  /** True when more rows, or groups with group_by, match than the limit; not the whole */
  truncated: boolean;
  /** How to narrow a read that was cut off; None when not */
  truncated_note?: string;
  /** Pass back with the same read for the next page */
  next_token?: string;
  /** True when more rows match but the next page lies past the deepest a read may page to; next_token is then None and the read is narrowed instead */
  paging_capped: boolean;
  /** How far the dataset has got (EM-UC-35) */
  freshness: EventDatasetStatus;
  /** True unless the dataset is current: recent events may be missing from the rows */
  behind: boolean;
}

// ============================================================================
// Live Events Models
// ============================================================================

/**
 * A live event from CloudWatch Logs
 */
export interface LiveEvent {
  /** Event ID (unique identifier) */
  id: string;
  /** Event timestamp (ISO 8601) */
  timestamp: string;
  /** Event source (e.g., 'cloud2.state-collector') */
  source: string;
  /** Event detail type (e.g., 'product-heartbeat') */
  detail_type: string;
  /** AWS region */
  region: string;
  /** AWS account ID */
  account: string;
  /** Event payload data */
  payload: Record<string, any>;
  /** Event resources */
  resources?: string[];
}

/**
 * Facets for filtering events
 */
export interface EventFacets {
  /** Unique event sources */
  sources?: string[];
  /** Unique detail types */
  detailTypes?: string[];
  /** Unique regions */
  regions?: string[];
  /** Unique account IDs */
  accounts?: string[];
}

/**
 * Response containing events and facets
 */
export interface EventsResponse {
  /** List of events */
  events: LiveEvent[];
  /** Total number of events returned */
  total: number;
  /** Whether more events are available */
  hasMore: boolean;
  /** Facets for filtering */
  facets: EventFacets;
}

// ============================================================================
// ITSM Ticket Models
// ============================================================================

/**
 * Vendor-neutral view of a note / conversation on a ticket
 */
export interface TicketNoteView {
  id?: string;
  body?: string;
  body_html?: string;
  private: boolean;
  created_at?: string;
}

/**
 * Vendor-neutral {id, name} reference for an ITSM lookup entity
 */
export interface ItsmEntityRef {
  id: number;
  name: string;
}

/**
 * Vendor-neutral read model for a ticket (canonical status/priority names)
 */
export interface TicketView {
  id: string;
  url?: string;
  subject?: string;
  description?: string;
  description_html?: string;
  status?: string;
  priority?: string;
  requester_id?: number;
  requester_name?: string;
  requester_email?: string;
  resolution?: string;
  created_at?: string;
  updated_at?: string;
  deleted: boolean;
  notes: TicketNoteView[];
}

/**
 * Request params for the itsm.GetTicket RPC method
 */
export interface GetTicketRequest {
  /** Customer ID (injected from investigation context) */
  customer_id: string;
  /** Freshservice ticket id */
  ticket_id: string;
}

/**
 * Request params for the itsm.ListTickets RPC method
 */
export interface ListTicketsRequest {
  /** Customer ID (injected from investigation context) */
  customer_id: string;
  /** ISO8601 timestamp; only tickets updated since are returned */
  updated_since?: string;
  /** Page number (default 1) */
  page?: number;
  /** Tickets per page (default 30) */
  per_page?: number;
}

/**
 * Request params for the itsm.UpdateTicket RPC method
 */
export interface UpdateTicketRequest {
  /** Customer ID (injected from investigation context) */
  customer_id: string;
  /** Freshservice ticket id */
  ticket_id: string;
  /** New status: open, pending, resolved, closed */
  status?: 'open' | 'pending' | 'resolved' | 'closed';
  /** New priority: low, medium, high, urgent */
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  /** Resolution note set on the ticket (required by some ITSM configurations to move a ticket to resolved). */
  resolution?: string;
}

/**
 * Request params for the itsm.AddTicketNote RPC method
 */
export interface AddTicketNoteRequest {
  /** Customer ID (injected from investigation context) */
  customer_id: string;
  /** Freshservice ticket id */
  ticket_id: string;
  /** Note content (HTML accepted). Added as a private note. */
  body: string;
}

/**
 * Result of a ticket mutation (update / add-note)
 */
export interface TicketMutationResult {
  success: boolean;
  ticket_id: string;
}

// ============================================================================
// Investigation RPC Request DTOs
// ============================================================================

/**
 * Request params for the investigations:ListInvestigations action.
 */
export interface ListInvestigationsRequest {
  customer_id: string;
}

/**
 * Request params for the investigations:GetInvestigation action.
 */
export interface GetInvestigationRequest {
  customer_id: string;
  investigation_id: string;
}

// ============================================================================
// Gamification Models
// ============================================================================

/**
 * Atomic unit of work within a quest
 */
export interface Task {
  /** Task ID (task-<uuid>) */
  id: string;
  /** Parent quest ID */
  quest_id: string;
  /** Short actionable description */
  title: string;
  /** Detailed instructions */
  description: string;
  complexity: TaskComplexityType;
  /** Domain tag for combo detection */
  domain_tag: string;
  /** Estimated completion time */
  estimated_minutes: number;
  status: TaskStatusType;
  /** User ID who claimed it */
  claimed_by?: string;
  /** ISO 8601 claim timestamp */
  claimed_at?: string;
  /** ISO 8601 completion timestamp */
  completed_at?: string;
  age_stage: TaskAgeStageType;
  quality_outcome: QualityOutcomeType;
  base_points: number;
  awarded_points: number;
  /** ISO 8601 creation timestamp */
  created_at: string;
  /** ISO 8601 last update timestamp */
  updated_at: string;
}

/**
 * Command for creating a task
 */
export interface TaskCreate {
  title: string;
  description?: string;
  complexity?: TaskComplexityType;
  domain_tag?: string;
  estimated_minutes?: number;
}

/**
 * Goal container with storyline
 */
export interface Quest {
  /** Quest ID (quest-<uuid>) */
  id: string;
  /** Customer ID (None = team-wide) */
  customer_id?: string;
  type: QuestTypeType;
  status: QuestStatusType;
  title: string;
  /** AI-generated storyline */
  narrative: string;
  /** What happens if quest fails */
  threat_narrative: string;
  completion_percentage: number;
  /** ISO 8601 deadline (hard or soft) */
  deadline?: string;
  is_hard_deadline: boolean;
  /** Current active phase */
  phase: number;
  total_phases: number;
  task_count: number;
  completed_task_count: number;
  total_points: number;
  awarded_points: number;
  /** Domain event that triggered quest creation */
  source_event_id?: string;
  /** ISO 8601 creation timestamp */
  created_at: string;
  /** ISO 8601 last update timestamp */
  updated_at: string;
  /** ISO 8601 completion timestamp */
  completed_at?: string;
}

/**
 * Player statistics sub-model
 */
export interface PlayerStats {
  total_xp: number;
  level: number;
  tasks_completed: number;
  quests_completed: number;
  daily_streak: number;
  session_streak: number;
  /** ISO 8601 date of last completed task */
  last_task_date?: string;
  /** ISO 8601 timestamp of last session */
  last_session_at?: string;
  /** Last 5 task domain tags completed (for combo detection) */
  recent_domain_tags: string[];
  /** Last 5 customer IDs for tasks completed (for cross_customer combo) */
  recent_customer_ids: string[];
}

/**
 * Progress in a mastery track
 */
export interface MasteryProgress {
  track: MasteryTrackType;
  xp: number;
  level: number;
  tasks_completed: number;
}

/**
 * Unlocked achievement
 */
export interface Achievement {
  /** Achievement ID */
  id: string;
  type: AchievementTypeType;
  title: string;
  description: string;
  /** ISO 8601 unlock timestamp */
  unlocked_at: string;
  xp_awarded: number;
}

/**
 * Player profile — one per OpsPilot user
 */
export interface Player {
  /** User ID (matches Cognito sub) */
  id: string;
  /** Display name for leaderboard */
  display_name: string;
  stats?: PlayerStats;
  mastery: MasteryProgress[];
  achievements: Achievement[];
  /** ISO 8601 creation timestamp */
  created_at: string;
  /** ISO 8601 last update timestamp */
  updated_at: string;
}

/**
 * A detected combo bonus
 */
export interface ComboEvent {
  combo_type: ComboTypeType;
  player_id: string;
  /** ISO 8601 timestamp */
  triggered_at: string;
  bonus_multiplier: number;
  task_ids: string[];
  xp_awarded: number;
}

/**
 * Result of completing a task, including scoring breakdown
 */
export interface TaskCompletion {
  task_id: string;
  quest_id: string;
  player_id: string;
  base_points: number;
  session_streak_multiplier: number;
  daily_streak_bonus: number;
  combo_bonus: number;
  total_points: number;
  new_session_streak: number;
  new_daily_streak: number;
  combo?: ComboEvent;
  completed_at: string;
}

/**
 * Per-customer entry in the fortress map view
 */
export interface FortressMapEntry {
  customer_id: string;
  health_score: number;
  active_quest_count: number;
  /** Number of critical/aging tasks (gaps in the wall) */
  gap_count: number;
}

/**
 * Single entry in the leaderboard
 */
export interface LeaderboardEntry {
  rank: number;
  player_id: string;
  display_name: string;
  total_xp: number;
  tasks_completed: number;
  daily_streak: number;
  level: number;
  /** MasteryTrack with highest XP */
  top_mastery: string;
}

/**
 * AI-generated (or computed) morning briefing
 */
export interface MorningBriefing {
  fortress_health: number;
  /** AI-generated narrative summary */
  narrative: string;
  /** Tasks needing immediate attention */
  critical_tasks: Record<string, any>[];
  /** Tasks < 5 min available now */
  quick_wins: Record<string, any>[];
  /** Summary of recent team activity */
  team_activity: string;
  /** ISO 8601 generation timestamp */
  generated_at: string;
}

/**
 * Request params for the game:ListQuests action.
 */
export interface ListQuestsRequest {
  /** Filter quests by customer ID */
  customer_id?: string;
}

/**
 * Request params identifying one quest (get quest / list its tasks).
 */
export interface QuestRef {
  /** Quest ID */
  quest_id: string;
}

/**
 * Request params identifying one task within a quest (claim / complete).
 */
export interface TaskRef {
  customer_id: string;
  quest_id: string;
  task_id: string;
}

/**
 * Request params for the game:UpdateTaskQuality action.
 */
export interface UpdateTaskQualityRequest {
  customer_id: string;
  quest_id: string;
  task_id: string;
  quality: string;
}

/**
 * Request params for the game:GetLeaderboard action.
 */
export interface GetLeaderboardRequest {
  /** Number of entries to return (default 20) */
  limit?: number;
}

/**
 * Request params for the game:ConfigureQuest action.
 */
export interface ConfigureQuestRequest {
  customer_id: string;
  title?: string;
  description?: string;
  type?: string;
  narrative?: string;
  threat_narrative?: string;
  deadline?: string;
  is_hard_deadline?: boolean;
  total_phases?: number;
  source_event_id?: string;
  tasks?: TaskCreate[];
}

// ============================================================================
// Service Offerings Readiness + RPC Request DTOs
// ============================================================================

/**
 * A single blocking issue for a component within an offering
 */
export interface ReadinessIssue {
  /** Machine-readable issue code */
  code: string;
  /** Human-readable detail (matches publish-time error message) */
  detail: string;
  /** CFN parameter keys with no binding (only for incomplete_bindings) */
  unbound_keys?: string[];
}

/**
 * Readiness verdict for one capability's enablement_ref to a component
 */
export interface ComponentReadiness {
  /** Resolved component id, or None when the component is missing */
  component_id?: string;
  /** Component name referenced by the capability's enablement_ref */
  name: string;
  /** Capability that references this component */
  capability_id: string;
  /** True when this component has no blocking issues */
  ready: boolean;
  issues: ReadinessIssue[];
}

/**
 * Readiness verdict for an offering-level requires_offerings prerequisite
 */
export interface RequiresOfferingReadiness {
  /** Required offering id */
  offering_id: string;
  /** True when the required offering exists and is active */
  satisfied: boolean;
  /** Why the prerequisite is unsatisfied */
  reason?: string;
}

/**
 * Structured pre-publish readiness verdict for a draft offering
 */
export interface OfferingReadinessReport {
  offering_id: string;
  version: string;
  /** True when every component and prerequisite is ready */
  ready: boolean;
  components: ComponentReadiness[];
  requires_offerings: RequiresOfferingReadiness[];
}

/**
 * One recorded check against an account, with when it was taken
 */
export interface ProbeView {
  name: string;
  ok: boolean;
  summary?: string;
  checked_at?: string;
  inconclusive?: boolean;
}

/**
 * One baseline stack of one AWS account, desired joined to what happened
 */
export interface BaselineStackView {
  component_name: string;
  region: string;
  tier: number;
  stack_name: string;
  baseline?: string;
  scope?: BaselineScopeType;
  status: BaselineStackStatusType;
  desired: boolean;
  summary?: string;
  applied_hash?: string;
  change_set_name?: string;
  blocked_reason?: string;
  refusals?: string[];
  credential_used?: string;
  observed_at?: string;
}

/**
 * One baseline of one AWS account: its layer and whether the account carries it
 */
export interface BaselineView {
  name: string;
  layer: BaselineLayerType;
  enabled: boolean;
  requires?: string[];
}

/**
 * One AWS account's baseline, in convergence order
 */
export interface AccountBaselineView {
  aws_account_id: string;
  account_name?: string;
  main_region?: string;
  supported_regions?: string[];
  enabled?: boolean;
  baseline_managed?: boolean;
  break_glass_required?: boolean;
  last_call_home_at?: string;
  probes?: ProbeView[];
  trust_verified_at?: string;
  trust_blocked_reason?: string;
  baselines?: BaselineView[];
  stacks?: BaselineStackView[];
}

/**
 * Every AWS account of one customer
 */
export interface AccountBaselineStatusRequest {
  customer_id: string;
}

/**
 * Per-account onboarding status for one customer
 */
export interface AccountBaselineStatusResponse {
  accounts: AccountBaselineView[];
}

/**
 * The baseline's own decisions about one AWS account
 */
export interface AccountBaselineSettings {
  customer_id: string;
  aws_account_id: string;
  baseline_managed?: boolean;
  break_glass_required?: boolean;
  optional_baselines?: string[];
  updated_at?: string;
}

/**
 * Whether OpsPilot installs one account's baselines itself
 */
export interface SetAccountBaselineManagedRequest {
  /** Customer ID */
  customer_id: string;
  /** The 12-digit AWS account ID */
  account_id: string;
  /** Whether OpsPilot installs and converges this account's CloudFormation baselines itself. Off by default: an account is moved onto that path deliberately, one at a time, and registering an account does not opt it in. */
  baseline_managed: boolean;
}

/**
 * Whether one account keeps Cloud2 read-only until the customer breaks glass
 */
export interface SetAccountBreakGlassRequest {
  /** Customer ID */
  customer_id: string;
  /** The 12-digit AWS account ID */
  account_id: string;
  /** Whether this account keeps Cloud2 at read-only until the customer breaks glass themselves. The admin role is created with a ReadOnlyAccess boundary clamped on it, and an SSM document in the customer's own tenant lifts and restores that clamp. For customers whose regulator does not permit Cloud2 to escalate its own access. */
  break_glass_required: boolean;
}

/**
 * Switch one optional baseline on or off for one account
 */
export interface SetAccountOptionalBaselineRequest {
  /** Customer ID */
  customer_id: string;
  /** The 12-digit AWS account ID */
  account_id: string;
  /** The optional baseline to switch, by name, for example 'finops'. A foundation baseline (access, signals, data) is carried by every managed account and is refused. */
  baseline: string;
  /** Whether this account carries the optional baseline. The next convergence installs its stacks when on, and proposes removing them when off. */
  enabled: boolean;
}

/**
 * Run one enrolled account's baseline now
 */
export interface RunAccountBaselineRequest {
  /** Customer ID */
  customer_id: string;
  /** The 12-digit AWS account ID. The account must be enrolled (baseline managed); any other is refused. */
  account_id: string;
}

/**
 * What starting one account's baseline run did
 */
export interface AccountBaselineRunResponse {
  /** Runs started: 1, or 0 when a run is already in flight for the account (backoff and a terminal mark do not hold it back) */
  dispatched: number;
  /** Runs that failed to start */
  errors: number;
  /** Accounts the dispatch found eligible to start */
  total_pending: number;
}

/**
 * Run the account baseline reconciler now
 */
export interface TriggerAccountBaselineReconcilerRequest {
  /** Reconciler domain type; must be 'aws-account-baseline' */
  domain_type: 'aws-account-baseline';
}

/**
 * Identifies one service offering.
 */
export interface OfferingRef {
  offering_id: string;
}

/**
 * Identifies one capability within an offering.
 */
export interface OfferingCapabilityRef {
  offering_id: string;
  capability_id: string;
}

/**
 * Publish one offering at a specific version.
 */
export interface PublishServiceOfferingRequest {
  offering_id: string;
  version: string;
}

/**
 * Identifies a customer whose subscriptions are being listed.
 */
export interface CustomerSubscriptionsRef {
  customer_id: string;
}

/**
 * Identifies one customer's subscription to an offering.
 */
export interface SubscriptionRef {
  customer_id: string;
  offering_id: string;
}

/**
 * Identifies one capability within a customer's subscription.
 */
export interface SubscriptionCapabilityRef {
  customer_id: string;
  offering_id: string;
  capability_id: string;
}

/**
 * Subscribe a customer to an offering.
 */
export interface CreateSubscriptionRequest {
  customer_id: string;
  offering_id: string;
  enabled_capabilities?: string[];
}

/**
 * Toggle one capability on/off for a customer's subscription.
 */
export interface ToggleCapabilityRequest {
  customer_id: string;
  offering_id: string;
  capability_id: string;
  enabled: boolean;
}

/**
 * Set operator-input binding values for a component's CFN parameters.
 */
export interface SetOperatorInputsRequest {
  customer_id: string;
  offering_id: string;
  component_name: string;
  inputs: Record<string, string>;
}

// ============================================================================
// Knowledge Base Responses + RPC Request DTOs
// ============================================================================

/**
 * Metadata for one document in a knowledge base
 */
export interface DocumentInfo {
  /** Document ID (S3 key) */
  document_id: string;
  /** Original filename */
  filename: string;
  /** File size in bytes */
  size_bytes: number;
  /** Last modification timestamp (ISO 8601) */
  last_modified: string;
  /** MIME type */
  content_type?: string;
  /** S3 ETag */
  etag?: string;
}

/**
 * List of documents in a knowledge base
 */
export interface DocumentListResponse {
  /** List of documents */
  documents: DocumentInfo[];
  /** Knowledge base ID */
  knowledge_base_id: string;
  /** Total number of documents */
  total_count: number;
  /** Total size of all documents */
  total_size_bytes: number;
}
/**
 * One page of a customer knowledge base document's text
 */
export interface DocumentTextResponse {
  /** Document ID */
  document_id: string;
  /** Original filename */
  filename: string;
  /** Customer knowledge base ID */
  knowledge_base_id: string;
  /** Length of the document's whole text */
  total_chars: number;
  /** Where this page starts */
  offset: number;
  /** The text of this page */
  content: string;
  /** Where the next page starts; null at the end */
  next_offset?: number;
}

/**
 * Result of a document upload
 */
export interface DocumentUploadResponse {
  /** Unique document ID (S3 key) */
  document_id: string;
  /** Pre-signed S3 URL for upload */
  upload_url: string;
  /** Form fields required for S3 POST upload */
  fields: Record<string, string>;
  /** Knowledge base ID */
  knowledge_base_id: string;
  /** URL expiration timestamp (ISO 8601) */
  expires_at: string;
}

/**
 * Counts for a knowledge-base sync job
 */
export interface SyncJobStatistics {
  /** Number of documents scanned */
  documents_scanned?: number;
  /** Number of documents modified */
  documents_modified?: number;
  /** Number of new documents added */
  documents_added?: number;
  /** Number of documents deleted */
  documents_deleted?: number;
  /** Number of documents that failed processing */
  documents_failed?: number;
}

/**
 * A started knowledge-base sync job
 */
export interface SyncJobResponse {
  /** Unique ingestion job ID */
  job_id: string;
  /** Knowledge base ID */
  knowledge_base_id: string;
  /** Data source ID */
  data_source_id: string;
  /** Job status: STARTING, IN_PROGRESS, COMPLETE, FAILED */
  status: string;
  /** Job start timestamp (ISO 8601) */
  started_at: string;
}

/**
 * Status of a knowledge-base sync job
 */
export interface SyncStatusResponse {
  /** Ingestion job ID */
  job_id: string;
  /** Knowledge base ID */
  knowledge_base_id: string;
  /** Data source ID */
  data_source_id: string;
  /** Job status: STARTING, IN_PROGRESS, COMPLETE, FAILED */
  status: string;
  /** Job start timestamp (ISO 8601) */
  started_at?: string;
  /** Job completion timestamp (ISO 8601) */
  completed_at?: string;
  /** Error message if job failed */
  error_message?: string;
  /** Job statistics */
  statistics?: SyncJobStatistics;
}

/**
 * Request params identifying one global knowledge base by id/alias.
 */
export interface KnowledgeBaseRef {
  /** Knowledge base ID or alias */
  kb_id: string;
}

/**
 * Request params scoping a knowledge base operation to one customer.
 */
export interface CustomerKnowledgeBaseRef {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params identifying one customer sync job to read.
 */
export interface CustomerSyncStatusRef {
  /** Customer ID */
  customer_id: string;
  /** Sync job ID */
  job_id: string;
}

/**
 * Request params for generating a customer document upload URL.
 */
export interface CustomerUploadDocumentRequest {
  /** Customer ID */
  customer_id: string;
  /** Filename with extension */
  filename: string;
  /** MIME type */
  content_type?: string;
}

// ============================================================================
// Ops Control-Plane RPC Request DTOs
// ============================================================================

/**
 * Request params identifying one reconciler domain.
 */
export interface ReconcilerDomainRef {
  /** Reconciler domain type */
  domain_type: string;
}

/**
 * Request params identifying one resource within a reconciler domain.
 */
export interface DomainResourceRef {
  /** Reconciler domain type */
  domain_type: string;
  /** Resource ID */
  resource_id: string;
}

/**
 * Request params for the ops:ListReconcilerResources action.
 */
export interface ListReconcilerResourcesRequest {
  /** Reconciler domain type (e.g. 'catalog', 'hello') */
  domain_type: string;
  /** Optional status filter */
  status?: string;
  /** Max resources per page (default 50, max 100) */
  limit?: number;
  /** Opaque pagination token from a previous response */
  next_token?: string;
}

/**
 * Request params for the ops:ListExecutions action.
 */
export interface ListExecutionsRequest {
  /** State machine ARN */
  state_machine_arn: string;
  /** Optional resource ID filter */
  resource_id?: string;
  /** Maximum number of results (default 20) */
  max_results?: number;
}

/**
 * Request params for the ops:GetExecutionDetail action.
 */
export interface GetExecutionDetailRequest {
  /** Execution ARN */
  execution_arn: string;
}

/**
 * Request params for the ops:Start action.
 */
export interface StartReconcilerRequest {
  /** Reconciler domain type */
  domain_type: string;
  /** Resource ID */
  resource_id: string;
  /** State machine ARN */
  state_machine_arn: string;
  /** The resource's full desired state. Open-ended: its shape is defined by the target reconciler domain (e.g. the 'rules' domain expects a rule snapshot, 'deployment' expects {'deployment_keys': [...]}), so there is no single schema for it. It REPLACES the stored desired state before the execution is triggered, so pass the whole thing, not a patch — read the current state with get_state first. Required: a partial or absent value would overwrite the stored state and reconcile the resource against nothing. */
  desired_data: Record<string, any>;
}

/**
 * Request params for the ops:GetCustomerControlPlane action.
 */
export interface GetCustomerControlPlaneRequest {
  /** Customer ID (slug) */
  customer_id: string;
}

/**
 * One switch's stored state. Groups, and background work beside them, are named only when the switch
is enabled for selected groups: on for everyone already includes background work, off excludes it.

Whether a group may be selected is checked where a state is set, not here: a stored state outlives
the groups it names, and a group that no longer exists is read, matches nobody and is flagged.
 */
export interface SwitchState {
  mode: SwitchModeType;
  groups: string[];
  background: boolean;
}

/**
 * One audit record: who set which switch, when, from what, to what, and the note they left.
 */
export interface FeatureSwitchMove {
  switch: string;
  from_state: SwitchState;
  to_state: SwitchState;
  actor_id: string;
  actor_email: string;
  note: string;
  at: string;
  version_number: number;
  deployment_number: number;
}

/**
 * Request params for ops:GetFeatureSwitches: none, the switches resolve for the caller.
 */
export type GetFeatureSwitchesRequest = Record<string, never>;

/**
 * Request params for ops:SetFeatureSwitch: the whole state the switch is to hold (ADR-0061).
 */
export interface SetFeatureSwitchRequest {
  /** The switch to set */
  switch: string;
  /** Off, on for the selected staff groups, or on for everyone */
  mode: SwitchModeType;
  /** The staff groups the switch is on for; named only, and at least one, when mode is groups */
  groups?: string[];
  /** Whether background work (automation rules, reconcilers) gets it too; true only when mode is groups */
  background: boolean;
  /** An optional note kept with the change */
  note?: string;
}

/**
 * Whether one switch is on for the caller.
 */
export interface ResolvedSwitch {
  name: string;
  on: boolean;
}

/**
 * One switch as a caller who may set it sees it. `state` is None when the store cannot be read;
`unknown_groups` are the groups the state names that no longer exist, which match nobody.
 */
export interface SwitchDetail {
  name: string;
  description: string;
  state: SwitchState;
  unreadable_reason: string;
  unknown_groups: string[];
  last_move: FeatureSwitchMove;
}

/**
 * Response of ops:GetFeatureSwitches. `can_set` says whether Cedar would let the caller call
ops:SetFeatureSwitch; `details` and `available_groups` are present only then.
 */
export interface FeatureSwitchesView {
  switches: ResolvedSwitch[];
  details: SwitchDetail[];
  available_groups: string[];
  can_set: boolean;
}

// ============================================================================
// Report Block Models (shared report/chat rendering)
// ============================================================================

/**
 * A single KPI figure in a metrics block
 */
export interface Metric {
  label: string;
  value: string;
  unit?: string;
  trend?: 'up' | 'down' | 'flat';
  note?: string;
}

/**
 * One named data series in a chart block
 */
export interface ChartSeries {
  label: string;
  data: number[];
}

/**
 * A decision arm off a timeline event
 */
export interface TimelineBranch {
  label: string;
  detail?: string;
}

/**
 * A single event in a timeline block
 */
export interface TimelineEvent {
  time: string;
  label: string;
  status?: string;
  detail?: string;
  branches?: TimelineBranch[];
}

/**
 * A single line item in a cost block
 */
export interface CostItem {
  label: string;
  value: number;
  period?: string;
}

/**
 * A node in a graph block
 */
export interface GraphNode {
  id: string;
  label: string;
  group?: string;
}

/**
 * A directed edge in a graph block
 */
export interface GraphEdge {
  source: string;
  target: string;
  label?: string;
}

/**
 * A recursive node in a tree block
 */
export interface TreeNode {
  label: string;
  detail?: string;
  status?: string;
  children?: TreeNode[];
}

/**
 * Prose paragraph block
 */
export interface ParagraphBlock {
  id?: string;
  kind: 'paragraph';
  text: string;
}

/**
 * Subsection heading within a section
 */
export interface HeadingBlock {
  id?: string;
  kind: 'heading';
  text: string;
}

/**
 * Row of KPI figures
 */
export interface MetricsBlock {
  id?: string;
  kind: 'metrics';
  metrics: Metric[];
}

/**
 * Tabular data block
 */
export interface TableBlock {
  id?: string;
  kind: 'table';
  columns: string[];
  rows: string[][];
}

/**
 * Highlighted note block
 */
export interface CalloutBlock {
  id?: string;
  kind: 'callout';
  variant: 'info' | 'ok' | 'warn' | 'err';
  title?: string;
  text: string;
}

/**
 * Data-carrying chart block (rendered downstream)
 */
export interface ChartBlock {
  id?: string;
  kind: 'chart';
  chart_type: 'bar' | 'line' | 'pie' | 'area';
  x_axis: string[];
  series: ChartSeries[];
  value_format?: 'number' | 'currency' | 'percent' | 'bytes' | 'duration';
  caption?: string;
}

/**
 * Chronological sequence of events
 */
export interface TimelineBlock {
  id?: string;
  kind: 'timeline';
  events: TimelineEvent[];
}

/**
 * Cost breakdown with proportion bars
 */
export interface CostBlock {
  id?: string;
  kind: 'cost';
  total: number;
  currency: string;
  period?: string;
  items: CostItem[];
}

/**
 * A list item with a bold lead label before its text
 */
export interface ListItem {
  label: string;
  text: string;
}

/**
 * Bullet or numbered list block
 */
export interface ListBlock {
  id?: string;
  kind: 'list';
  ordered: boolean;
  items: (string | ListItem)[];
}

/**
 * Relational/topological diagram (nodes + edges)
 */
export interface GraphBlock {
  id?: string;
  kind: 'graph';
  layout: 'dag' | 'tree';
  nodes: GraphNode[];
  edges: GraphEdge[];
  caption?: string;
}

/**
 * Hierarchy of recursive nodes (forest-capable)
 */
export interface TreeBlock {
  id?: string;
  kind: 'tree';
  roots: TreeNode[];
  caption?: string;
}

/**
 * Section break
 */
export interface DividerBlock {
  id?: string;
  kind: 'divider';
}

/**
 * A titled section of ordered report blocks
 */
export interface Section {
  id?: string;
  title: string;
  role?: 'summary' | 'body' | 'appendix';
  blocks?: ReportBlock[];
}

/**
 * A renderable report — titled document of sections
 */
export interface Report {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  period_label?: string;
  generated_at: string;
  sections?: Section[];
}

/**
 * Discriminated union of all report block kinds (discriminate on `kind`)
 */
export type ReportBlock =
  | ParagraphBlock
  | HeadingBlock
  | MetricsBlock
  | TableBlock
  | CalloutBlock
  | ChartBlock
  | TimelineBlock
  | CostBlock
  | ListBlock
  | GraphBlock
  | TreeBlock
  | DividerBlock;

// ============================================================================
// WebSocket Event Types
// ============================================================================

/**
 * Text content chunk from agent (streaming response)
 */
export interface WebSocketChunkMessage {
  /** Event type */
  type?: 'chunk';
  /** Text content chunk */
  text: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
}

/**
 * Live wire envelope carrying a tool_start / tool_complete ObservabilityEvent
 */
export interface WebSocketObservabilityMessage {
  /** Event type */
  type?: 'observability';
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
  /** The observability event */
  event: ObservabilityEvent;
}

/**
 * Stream completion event with metadata
 */
export interface WebSocketCompleteMessage {
  /** Event type */
  type?: 'complete';
  /** Token accounting for the completed turn */
  usage?: TokenUsage;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
}

/**
 * Error event sent to client
 */
export interface WebSocketErrorMessage {
  /** Event type */
  type?: 'error';
  /** Error code for client-side handling */
  code: string;
  /** Human-readable error message */
  message: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
}

/**
 * Extended Thinking reasoning content from Claude
 */
export interface WebSocketReasoningMessage {
  /** Event type */
  type?: 'reasoning';
  /** Reasoning text from Claude's Extended Thinking */
  content: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
  /** True when reasoning block finishes */
  is_complete?: boolean;
}

/**
 * Real-time notification that a finding was added to the investigation
 */
export interface WebSocketFindingAddedMessage {
  /** Event type */
  type?: 'finding_added';
  /** ID of the added finding */
  finding_id: string;
  /** Finding title */
  title: string;
  /** Finding summary */
  summary?: string;
  /** Finding description */
  description?: string;
  /** Finding priority rank */
  rank?: number;
  /** Whether finding is irrelevant */
  irrelevant?: boolean;
  /** Whether finding is a potential root cause */
  potential_root_cause?: boolean;
  /** Finding tags */
  tags?: string[];
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
}

/**
 * Live notification that the agent emitted one inline block to render in chat
 */
export interface WebSocketBlockMessage {
  /** Event type */
  type?: 'block';
  /** Validated ReportBlock-shaped payload */
  block: Record<string, any>;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation ID this event belongs to */
  investigation_id: string;
}

// ============================================================================
// Unified Message Model (works for streaming AND history)
// ============================================================================

/**
 * Observability event - what the agent is DOING (thinking, tool calls)
 */
export interface ObservabilityEvent {
  /** Unique event identifier */
  event_id: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Type of observability event */
  event_type: 'thinking' | 'tool_start' | 'tool_complete';
  /** Human-readable description */
  message: string;
  /** Tool name if applicable */
  tool_name?: string;
  /** Tool use ID for correlation */
  tool_use_id?: string;
  /** Execution duration (tool_complete only) */
  duration_ms?: number;
  /** Tool execution status */
  status?: 'success' | 'error';
  /** Error message if status is error */
  error_message?: string;
  /** Compact summary of tool call parameters */
  context_summary?: string;
}

/**
 * Unified conversation message - works for BOTH streaming AND history
 */
export interface ConversationMessage {
  /** Unique message identifier */
  id: string;
  /** Message sender role */
  role: 'user' | 'assistant';
  /** Message text content (never raw JSON) */
  content: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Investigation this message belongs to */
  investigation_id: string;
  /** Thinking steps and tool executions for this message */
  observability?: ObservabilityEvent[];
  /** Inline ReportBlock visualizations rendered with this message */
  blocks?: ReportBlock[];
  /** Token accounting for the turn that produced this message (assistant messages only) */
  token_usage?: TokenUsage;
  /** True while message is being streamed */
  is_streaming?: boolean;
  /** True when message is finalized */
  is_complete?: boolean;
}

/**
 * Union type for all WebSocket messages
 */
export type WebSocketMessage =
  | WebSocketChunkMessage
  | WebSocketObservabilityMessage
  | WebSocketReasoningMessage
  | WebSocketCompleteMessage
  | WebSocketErrorMessage
  | WebSocketFindingAddedMessage
  | WebSocketBlockMessage;

/**
 * Chat message in conversation history
 */
export interface Message {
  id: string;
  content: string;
  role: MessageRoleType;
  timestamp: string;
  investigation_id: string;
  message_type?: MessageTypeType;
  tool_name?: string | null;
}

// ============================================================================
// Auto-emitted RPC request models (derived from Action.request_model)
// ============================================================================

/**
 * Stop a run that will not finish.
 */
export interface AbandonWorkflowRunRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** Why the run is being stopped */
  reason: string;
}

/**
 * Request params for the investigations:AddFinding action.
 */
export interface AddFindingRequest {
  /** Concise title (5-10 words) describing the issue */
  title: string;
  /** Markdown with sections: Summary, Details, Evidence, Impact, Recommendations */
  description: string;
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Plain text 1-2 sentence summary, at most 300 characters */
  summary?: string;
  /** Relevance rank (0=most relevant) */
  rank?: number;
  /** Mark as irrelevant */
  irrelevant?: boolean;
  /** DO NOT SET. User decision only. */
  potential_root_cause?: boolean;
  /** ONLY set when user explicitly asks. */
  tags?: string[];
}

/**
 * Check a workflow's access needs against the caller's access, before starting it.
 */
export interface CheckWorkflowAccessRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** The workflow's snake_case name */
  workflow_name: string;
}

/**
 * Record one step as done.
 */
export interface CompleteStepRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** The step's node id, from get_current_step */
  node_id: string;
  /** What you did and what it showed; recorded on the run */
  evidence: string;
  /** The facts this step declares in evidence_required, keyed exactly as it names them. Omitting one, or leaving it blank, refuses the completion; a step that declares none takes none */
  facts?: Record<string, string>;
}

/**
 * Request params for the customers:CreateAWSAccount tool action.

The automation and onboarding role names are not here: they name
administrator roles, so they are set on customers:SetAWSAccountAdminRoles.
 */
export interface CreateAWSAccountRequest {
  /** Customer ID */
  customer_id: string;
  /** 12-digit AWS account number */
  aws_account_id: string;
  /** Human-readable account name */
  account_name: string;
  /** IAM role name for read access (assumed cross-account) */
  read_role_name: string;
  /** Primary AWS region (e.g. eu-central-1) */
  main_region: string;
  /** All AWS regions the account operates in */
  supported_regions: string[];
  /** IAM role name for write access */
  write_role_name?: string;
  /** External ID for role assumption */
  external_id?: string;
  /** EventBridge bus name in the customer account (default: cloud2-events) */
  event_bus_name?: string;
}

/**
 * A new agent, whole: the id it keeps, the shape it is invoked as, and everything it needs to run
(ADR-0064 decisions 1, 2; PS-UC-15).

Strict (``extra='forbid'``). There is no status: a new agent is active. The shape is chosen here
once; no update changes it. The same field checks as an update hold, and the service runs every
write-boundary check on the row before it is written.
 */
export interface CreateAgentRequest {
  agent_id: string;
  display_name: string;
  description: string;
  shape: InvocationShapeType;
  model_id: string;
  max_tokens: number;
  thinking_effort?: string;
  context_window_size?: number;
  system_prompt_ref: string;
  tool_loadout: ToolLoadout;
  callees: string[];
}

/**
 * A JSON number from min to max, both inclusive, becomes value.
 */
export interface ValueBand {
  /** Lowest number in the band, inclusive */
  min: number;
  /** Highest number in the band, inclusive */
  max: number;
  /** The column's value for a number in the band, of the column's type */
  value: any;
}

/**
 * One rule of a first_of: the path it reads and how it translates the value found there.
 */
export interface TranslationRule {
  /** Dotted path, read like a plain mapping path */
  path: string;
  /** A text or boolean value (true and false as text) -> the column's value; a value not listed does not fit */
  values?: Record<string, any>;
  /** Number ranges -> the column's value; read JSON numbers only, and the ranges may not overlap */
  bands?: ValueBand[];
  /** Values that pass to the next rule instead of not fitting; never on the last rule */
  continue_on?: string[];
}

/**
 * Rules tried in order; the first that takes a value gives the column its value.
 */
export interface FirstOf {
  first_of: TranslationRule[];
}

/**
 * One event format feeding the dataset: its pattern and where each column reads from in it.
 */
export interface DatasetInput {
  /** Event pattern in the rule pattern language (EM-UC-08) */
  event_pattern: Record<string, any>;
  /** Column name -> its source in this input: a dotted path such as `Resources[0].Id`, read from the row element when the dataset has a row path and from the event otherwise (a `$event.` prefix reads the event root); null when this input does not provide an optional column; or `{first_of: [rule, ...]}`, rules tried in order that may translate the value. Gives every operator column a source, and may give `resource` a path. */
  mapping: Record<string, string | FirstOf | null>;
}

/**
 * One typed column of the dataset's tables.
 */
export interface DatasetColumn {
  /** Column name in the dataset's tables */
  name: string;
  /** text, number, timestamp, boolean, list or json */
  type: 'text' | 'number' | 'timestamp' | 'boolean' | 'list' | 'json';
  /** An event lacking a required field does not fit; a missing optional field leaves the column empty */
  required: boolean;
}

/**
 * The body of an Event Dataset definition, without a customer: what a template holds and a
dataset extends with its customer.
 */
export interface EventDatasetDefinition {
  /** Lowercase letters, digits and underscore, starting with a letter, at most 64 */
  name: string;
  /** One to four inputs, each an event format feeding the same columns, identified by position; an event matching more than one does not fit */
  inputs: DatasetInput[];
  /** Dotted path from the event root to the list whose elements each become a row, such as `detail.findings`; omitted means one event is one row */
  row_path?: string;
  /** The operator's columns; the standard columns come first and are not listed here */
  columns: DatasetColumn[];
  /** Whether an event without a resource does not fit; False makes such an event a row with an empty resource, for events about a whole account. An optional resource cannot be a key field */
  resource_required?: boolean;
  /** Columns identifying the thing a row is about; each must be required */
  key_fields: string[];
  /** Column deciding the newest row for a key; omitted means event_time */
  ordering_field?: string;
  /** Keep a current state per key beside the history */
  keep_current_state: boolean;
  /** Days of history kept; at most the raw archive's retention */
  retention_days: number;
  /** Only events in v1 */
  source?: 'events';
}

/**
 * Params for prompts:CreateCustomerPrompt — the full PromptCreateRequest fields
plus the customer_id the handler reads from params.
 */
export interface CreateCustomerPromptRequest {
  /** Prompt name */
  name: string;
  /** Human-readable title (shown in UI) */
  title: string;
  /** Prompt type */
  type?: PromptTypeType;
  /** Prompt description */
  description?: string;
  /** Prompt content (markdown) */
  content: string;
  /** AWS account scope (required for playbook type) */
  accountScope?: PromptAccountScopeType;
  /** Tags for categorization */
  tags?: string[];
  /** Which invocation shape(s) can use this skill: interactive, batch or both */
  agentType?: SkillApplicabilityType;
  /** Customer ID (injected from investigation context) */
  customer_id: string;
}

/**
 * One outgoing route from a decision node.

``condition`` is the operator-readable test ("Attack Sequence detected"). It is prose on
purpose: the agent evaluates it. What the data fixes is the *set* of routes available and
where each one lands, never which one gets taken.
 */
export interface WorkflowBranch {
  condition: string;
  /** Layer this branch jumps to; must be later */
  target_layer: number;
}

/**
 * One unit of work in a workflow.
 */
export interface WorkflowNode {
  id: string;
  /** Shown to the operator */
  label: string;
  layer: number;
  kind?: WorkflowNodeKindType;
  /** What this node must achieve */
  goal: string;
  /** Completion requires a recorded human approval before the run may advance */
  gate?: boolean;
  /** Node ids in the SAME layer that must complete first */
  depends_on?: string[];
  /** Decision routes; empty for a step node */
  branches?: WorkflowBranch[];
  /** Tool names, as the agent sees them, this node may use for write-level work while a run is on it, each as 'tool' or 'tool:mode'. A mode is only legal on a tool whose authorization depends on a param (use_aws_customer:write); a plain name for such a tool grants only its least-privileged mode. Read-level tools are never restricted in their least mode, and a stronger mode of one is listed like a write; any other tool is refused, and so is every escalation tool. The guard sees only the agent's own calls, so allowing a tool that runs its own AWS session (use_aws_customer) allows every write it can make. A specialist (aws_specialist or any other sub_agent) is not such a tool: its own calls face this step's guard too, so the step must list the tools the specialist needs. */
  allowed_tools?: string[];
  /** Evidence keys this step reads, each produced by an earlier step. Declaring them is what lets the step run with a context built from those facts alone: isolated from the conversation, beside its siblings in the same stage, and replayed later as an eval case. A key no reachable route produces is refused at authoring time. */
  inputs?: string[];
  /** Facts this step must record to be complete, each a snake_case key such as 'finding_id'. Completing the step without one of them is refused, so a key here is a claim the step cannot be waved through. Name what the step establishes, never how it was obtained. */
  evidence_required?: string[];
}

/**
 * Author a new workflow. It starts as DRAFT and is not runnable until published.
 */
export interface CreateWorkflowRequest {
  name: string;
  title: string;
  description?: string;
  nodes: WorkflowNode[];
  tags?: string[];
}

/**
 * Request params for the knowledge:CustomerDeleteDocument action.
 */
export interface CustomerDeleteDocumentRequest {
  /** Customer ID */
  customer_id: string;
  /** Document ID */
  doc_id: string;
}

/**
 * Request params for the knowledge:CustomerGetDocumentContent action.
 */
export interface CustomerGetDocumentContentRequest {
  /** Customer ID */
  customer_id: string;
  /** document_id from customer_list_documents */
  document_id: string;
  /** Character offset to read from; pass next_offset to read on */
  offset?: number;
}

/**
 * Request params for the knowledge:CustomerQueryKnowledgeBase action.
 */
export interface CustomerQueryKnowledgeBaseRequest {
  /** Customer ID */
  customer_id: string;
  /** Search query */
  query: string;
  /** Maximum number of results */
  num_results?: number;
}

/**
 * Request params for the investigations:DeleteFindings action.
 */
export interface DeleteFindingsRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Finding index (0-based) */
  finding_index?: number;
  /** Finding IDs to delete (RPC alternative to finding_index) */
  finding_ids?: string[];
}

/**
 * Request params identifying one GLOBAL template to delete
(events:DeleteGlobalTemplate).

Irreversible, and it removes a template every customer's rules may derive from.
 */
export interface DeleteGlobalTemplateRequest {
  /** Template ID */
  template_id: string;
}

/**
 * Request params for the investigations:DeleteKnowledgeItems action.
 */
export interface DeleteKnowledgeItemsRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Item index (0-based) */
  item_index?: number;
  /** Knowledge item IDs to delete (RPC alternative to item_index) */
  knowledge_item_ids?: string[];
}

/**
 * Request params identifying one rule to delete (events:DeleteRule).
 */
export interface DeleteRuleRequest {
  /** Customer ID */
  customer_id: string;
  /** Rule ID */
  rule_id: string;
}

/**
 * Request params identifying one CUSTOMER-owned template to delete
(events:DeleteTemplate).

No `owner` field, for the same reason as UpdateTemplateRequest: this action is
authorized against one Customer, so it can only delete that customer's own
template. Deleting a global template — shared by every customer, and
irreversible — goes through events:DeleteGlobalTemplate.
 */
export interface DeleteTemplateRequest {
  /** Customer ID that owns the template */
  customer_id: string;
  /** Template ID */
  template_id: string;
}

/**
 * Delete every version of a workflow.
 */
export interface DeleteWorkflowRequest {
  workflow_id: string;
}

/**
 * Request params for TOOL actions that take no input. Used for the agent-tool
schema only (an empty inputSchema) — shared across every no-arg TOOL action.
 */
export type EmptyRequest = Record<string, never>;

/**
 * The definition of one customer's Event Dataset.
 */
export interface EventDataset {
  /** Lowercase letters, digits and underscore, starting with a letter, at most 64 */
  name: string;
  /** One to four inputs, each an event format feeding the same columns, identified by position; an event matching more than one does not fit */
  inputs: DatasetInput[];
  /** Dotted path from the event root to the list whose elements each become a row, such as `detail.findings`; omitted means one event is one row */
  row_path?: string;
  /** The operator's columns; the standard columns come first and are not listed here */
  columns: DatasetColumn[];
  /** Whether an event without a resource does not fit; False makes such an event a row with an empty resource, for events about a whole account. An optional resource cannot be a key field */
  resource_required?: boolean;
  /** Columns identifying the thing a row is about; each must be required */
  key_fields: string[];
  /** Column deciding the newest row for a key; omitted means event_time */
  ordering_field?: string;
  /** Keep a current state per key beside the history */
  keep_current_state: boolean;
  /** Days of history kept; at most the raw archive's retention */
  retention_days: number;
  /** Only events in v1 */
  source?: 'events';
  customer_id: string;
}

/**
 * Request params for the game:GetCustomerHealth action.
 */
export interface GetCustomerHealthRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params for the knowledge:GetDocumentContent action.
 */
export interface GetDocumentContentRequest {
  /** Knowledge base ID */
  kb_id: string;
  /** Document path/key */
  path: string;
}

/**
 * Request params for the raw archive's retention of one customer (events:GetEventDatasetRetentionCeiling).
 */
export interface GetEventDatasetRetentionCeilingRequest {
  /** Customer ID */
  customer_id: string;
}

/**
 * Request params for the investigations:GetFindings action.
 */
export interface GetFindingsRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** False lists each finding without its description, with the description's length instead */
  include_description?: boolean;
  /** 0-based index of one finding to return in full */
  finding_index?: number;
  /** ID of one finding to return in full */
  finding_id?: string;
}

/**
 * Request params for the investigations:GetKnowledgeItems action.
 */
export interface GetKnowledgeItemsRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
}

/**
 * Request params for events:GetRuleSampleEvent.
 */
export interface GetRuleSampleEventRequest {
  /** Customer ID */
  customer_id: string;
  /** Rule ID */
  rule_id: string;
}

/**
 * Fetch one workflow. Omitting `version` returns the highest published version.

A run resolves its pinned version explicitly; only the Studio asks for 'the current one'.
 */
export interface GetWorkflowRequest {
  workflow_id: string;
  /** 'DRAFT', an integer string, or omitted for latest published */
  version?: string;
}

/**
 * Show an existing run in this investigation, without taking it from anywhere else.
 */
export interface LinkWorkflowRunRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** The run to show here, as list_customer_workflow_runs gives it */
  run_id: string;
}

/**
 * Every workflow run of this customer, however it is reached.

A run that no investigation links has no other handle to be found by, so this names no run and
no investigation. It declares `customer_id` because the action is customer-scoped and the
authorization wall reads that parameter to decide the call; the handler ignores what it says and
takes the customer from the verified context, so a request cannot name someone else's.
 */
export interface ListCustomerWorkflowRunsRequest {
  /** Customer ID */
  customer_id?: string;
}

/**
 * Request params for the knowledge:ListDocuments action.
 */
export interface ListDocumentsRequest {
  /** Knowledge base ID */
  kb_id: string;
  /** S3 key prefix filter */
  prefix?: string;
}

/**
 * List the workflows that can be started, by name.
 */
export interface ListRunnableWorkflowsRequest {
  /** Customer ID */
  customer_id?: string;
}

/**
 * List every workflow run on an investigation with its progress.
 */
export interface ListWorkflowRunsRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
}

/**
 * List workflow definitions. Drafts are included so the Studio can show unpublished work.
 */
export interface ListWorkflowsRequest {
  /** Include DRAFT versions in the listing */
  include_drafts?: boolean;
}

/**
 * Freeze the current DRAFT as the next integer version.
 */
export interface PublishWorkflowRequest {
  workflow_id: string;
}

/**
 * Request params for the customers:ReorderOperationalContacts tool action.
 */
export interface ReorderOperationalContactsRequest {
  /** Customer ID */
  customer_id: string;
  /** Usernames in priority order */
  ordered_usernames: string[];
}

/**
 * Record that an eligible step could not be done; the run blocks until a human retries it.
 */
export interface ReportStepFailedRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** The step's node id, from get_current_step */
  node_id: string;
  /** What you tried and what went wrong; recorded on the run */
  error: string;
}

/**
 * Params for customers:RequestEscalation. The handler builds an
EscalationRequest from requested_level + duration_minutes, so all three fields
are part of the contract.
 */
export interface RequestEscalationRequest {
  /** Customer ID (injected from investigation context) */
  customer_id: string;
  /** Escalation level to request: l2 or admin */
  requested_level: 'l2' | 'admin';
  /** How long the escalation lasts, in minutes: 15, 30, 120, 240, or 480 */
  duration_minutes: 15 | 30 | 120 | 240 | 480;
}

/**
 * Ask the operator to approve a gated step.
 */
export interface RequestWorkflowGateRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** The gated node's id */
  node_id: string;
  /** What you are asking them to allow, and why */
  reason: string;
}

/**
 * Approve or reject an open gate. RPC-only; `resolved_by` comes from the caller's identity.
 */
export interface ResolveWorkflowGateRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** The gated node's id */
  node_id: string;
  /** True to allow the step, False to stop the run */
  approved: boolean;
  /** Optional note recorded with the decision */
  note?: string;
}

/**
 * The agent to retire, by id (PS-UC-18).
 */
export interface RetireAgentRequest {
  agent_id: string;
}

/**
 * Send a failed step back to be tried again. RPC-only; `retried_by` is the caller.
 */
export interface RetryWorkflowStepRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** The failed node's id */
  node_id: string;
}

/**
 * Request params for customers:SetAWSAccountAdminRoles.

Both fields name an administrator role Cloud2 assumes inside the customer's
account, so they are set here, at admin level, and on neither the create nor
the update request. A field left out keeps its stored value.
 */
export interface SetAWSAccountAdminRolesRequest {
  /** Customer ID */
  customer_id: string;
  /** Internal AWS account record ID (from list_aws_accounts) */
  account_id: string;
  /** IAM role name for automation (Lambda invoke, SSM, Service Catalog) */
  automation_role_name?: string;
  /** IAM role name the customer installs by hand before onboarding. It is the only way into a fresh account, since the roles OpsPilot uses afterwards are created by the stack it installs through this one. */
  onboarding_role_name?: string;
}

/**
 * Which playbook, at which version, and whose it is.

Deliberately not `PlaybookCreateInput`: that carries `variables`, which nothing on a stored
`PlaybookReference` holds, so accepting them here would take substitutions and drop them.
 */
export interface PlaybookChoice {
  /** Playbook ID to attach */
  id: string;
  /** Version to follow, such as '2' */
  version: string;
  /** Playbook owner (customer or global) */
  owner: PromptOwnerType;
}

/**
 * Attach, change or clear the playbook an open investigation follows.

`playbook` omitted or null clears it. That is a choice rather than a missing field: an
operator deciding this case follows no playbook has to be able to say so.
 */
export interface SetInvestigationPlaybookRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** The playbook to follow; null to follow none */
  playbook?: PlaybookChoice;
}

/**
 * Begin a run of a named workflow, on this investigation when the caller has one.
 */
export interface StartWorkflowRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** The workflow's snake_case name, e.g. 'customer_account_onboarding' */
  workflow_name: string;
}

/**
 * Resolve a decision node onto one of the branches it offers.
 */
export interface TakeBranchRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
  /** The decision node's id */
  node_id: string;
  /** Exactly one of the node's branch conditions */
  condition: string;
  /** Why this branch and not the others */
  reason: string;
}

/**
 * Request params for the events:TriggerReconciler action.
 */
export interface TriggerReconcilerRequest {
  /** Reconciler domain type (e.g. 'rules') */
  domain_type: 'rules';
}

/**
 * Request params for the customers:UpdateAWSAccount tool action.

The automation and onboarding role names are not here: they name
administrator roles, so they are set on customers:SetAWSAccountAdminRoles.
 */
export interface UpdateAWSAccountRequest {
  /** Customer ID */
  customer_id: string;
  /** Internal AWS account record ID (from list_aws_accounts) */
  account_id: string;
  /** 12-digit AWS account number. It cannot change: accepted only when it names the account being updated, and never written */
  aws_account_id?: string;
  /** Human-readable account name */
  account_name?: string;
  /** IAM role name for read access */
  read_role_name?: string;
  /** IAM role name for write access */
  write_role_name?: string;
  /** External ID for role assumption */
  external_id?: string;
  /** EventBridge bus name in the customer account */
  event_bus_name?: string;
  /** Primary AWS region */
  main_region?: string;
  /** All AWS regions the account operates in */
  supported_regions?: string[];
  /** Whether the account is active */
  enabled?: boolean;
}

/**
 * Request params for the customers:UpdateContactMetadata tool action.
 */
export interface UpdateContactMetadataRequest {
  /** Customer ID */
  customer_id: string;
  /** Portal user username */
  username: string;
  /** Contact type labels */
  contact_types?: string[];
  /** Role label */
  role?: string;
}

/**
 * Request params for the customers:UpdateCustomerContactTypes tool action.
 */
export interface UpdateCustomerContactTypesRequest {
  /** Customer ID */
  customer_id: string;
  /** New list of contact type labels */
  contact_types: string[];
}

/**
 * Params for prompts:UpdateCustomerPrompt — the partial PromptUpdateRequest fields
plus the customer_id + prompt_id the handler reads from params.
 */
export interface UpdateCustomerPromptRequest {
  /** Prompt name (alphanumeric, underscores, hyphens) */
  name?: string;
  /** Human-readable title (shown in UI) */
  title?: string;
  /** Prompt description */
  description?: string;
  /** Prompt content (markdown) */
  content?: string;
  /** AWS account scope */
  accountScope?: PromptAccountScopeType;
  /** Tags for categorization */
  tags?: string[];
  /** Which invocation shape(s) can use this skill: interactive, batch or both */
  agentType?: SkillApplicabilityType;
  /** Customer ID (injected from investigation context) */
  customer_id: string;
  /** Prompt ID */
  prompt_id: string;
}

/**
 * Request params for the customers:UpdateEscalationChain tool action.
 */
export interface UpdateEscalationChainRequest {
  /** Customer ID */
  customer_id: string;
  /** Ordered list of escalation levels */
  levels: Record<string, any>[];
  /** Available channel integrations */
  available_channels?: Record<string, any>[];
}

/**
 * Request params for the investigations:UpdateFinding action.
 */
export interface UpdateFindingRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Finding index (0-based) */
  finding_index?: number;
  /** Finding ID (RPC alternative to finding_index) */
  finding_id?: string;
  /** New title */
  title?: string;
  /** New plain text summary, at most 300 characters */
  summary?: string;
  /** New description */
  description?: string;
  /** New priority rank */
  rank?: number;
  /** Mark as irrelevant */
  irrelevant?: boolean;
  /** DO NOT SET. User decision only. */
  potential_root_cause?: boolean;
  /** ONLY set when user explicitly asks. */
  tags?: string[];
}

/**
 * Request params for updating a GLOBAL template (events:UpdateGlobalTemplate).

A global template is shared by every customer — editing one changes the rules
all of them derive. Hence its own globally-scoped action, mirroring
events:CreateGlobalTemplate.
 */
export interface UpdateGlobalTemplateRequest {
  /** Template name */
  name?: string;
  /** Template description */
  description?: string;
  /** Template category: Security, Cost, Compute, Storage, Governance, Monitoring, Database or Custom */
  category?: string;
  /** Free-form tags */
  tags?: string[];
  /** Rule classification: 'alert' or 'automation' */
  rule_type?: string;
  /** How rules from this template fire: 'event' or 'schedule' */
  trigger_type?: string;
  /** EventBridge event pattern (for trigger_type='event') */
  event_pattern?: Record<string, any>;
  /** cron(...) or rate(...) expression (for trigger_type='schedule') */
  schedule_expression?: string;
  /** ITSM (Freshservice ticket) delivery config: {priority, agent_group_id, format_prompt_id} */
  itsm_config?: Record<string, any>;
  /** Rule-level enrichment prompt (source-aware understanding) */
  enrichment_prompt_id?: string;
  /** Prompt ID for the automation agent */
  automation_prompt_id?: string;
  /** Agent that runs automation_prompt_id: an active batch agent, e.g. 'automation'; required with it */
  automation_agent_id?: string;
  /** Notification targets: [{type: 'email'|'sns', to: [...]}] */
  notifications?: Record<string, any>[];
  /** Per-key content overrides {output_field: JSONPath or fixed text}; a filled key wins over the AI output */
  field_mappings?: Record<string, string>;
  /** Strategy for OpsItem creation: track (dedup by rule), always_new (fresh each time), fingerprint (dedup by chosen event fields) */
  opsitem_strategy?: OpsItemStrategyType;
  /** Template ID */
  template_id: string;
}

/**
 * Request params for the customers:UpdatePortalUser tool action.
 */
export interface UpdatePortalUserRequest {
  /** Customer ID */
  customer_id: string;
  /** Portal user username */
  username: string;
  /** Display name */
  name?: string;
  /** Phone number in E.164 format */
  phone_number?: string;
}

/**
 * Edit the DRAFT version in place. Published versions are immutable and reject this.
 */
export interface UpdateWorkflowDraftRequest {
  workflow_id: string;
  /** The draft's `updated_at` as the author opened it. Required: the save is refused if someone else saved in the meantime, which is what stops two authors erasing each other. A value read just before saving would satisfy any condition and prove nothing. */
  expected_updated_at: string;
  title?: string;
  description?: string;
  nodes?: WorkflowNode[];
  tags?: string[];
}

/**
 * The boto3 call a role validation executes with the assumed role, as
``RoleValidationService`` reads it: service_name / operation_name / parameters
/ region.
 */
export interface AWSOperationProbe {
  /** AWS region to run the operation in (required — no default is applied) */
  region: string;
  /** boto3 service name, e.g. 'sts', 's3', 'ec2' (default: 'sts') */
  service_name?: string;
  /** snake_case boto3 operation to call on that service, e.g. 'get_caller_identity', 'list_buckets', 'describe_instances' (default: 'get_caller_identity') */
  operation_name?: string;
  /** Keyword arguments passed to the boto3 operation, in boto3's own PascalCase form, e.g. {"Bucket": "my-bucket"}. Omit for an operation that takes none. */
  parameters?: Record<string, any>;
}

/**
 * Request params for the customers:ValidateOpsRoleAccess tool action.
 */
export interface ValidateOpsRoleAccessRequest {
  /** Customer ID */
  customer_id: string;
  /** Role type */
  role_type?: 'readonly' | 'write' | 'automation';
  /** AWS operation to probe once the role is assumed. Required: RoleValidationService rejects a probe with no region, so there is no meaningful call without it. */
  aws_operation: AWSOperationProbe;
}

/**
 * Request params for the customers:ValidateRoleAccess tool action.
 */
export interface ValidateRoleAccessRequest {
  /** Customer ID */
  customer_id: string;
  /** AWS account ID */
  account_id: string;
  /** Role type */
  role_type?: 'readonly' | 'write' | 'automation';
  /** AWS operation to probe once the role is assumed. Required: RoleValidationService rejects a probe with no region, so there is no meaningful call without it. */
  aws_operation: AWSOperationProbe;
}

/**
 * Address one run: read it, or read where it currently stands.
 */
export interface WorkflowRunRefRequest {
  /** Customer ID */
  customer_id?: string;
  /** Investigation ID */
  investigation_id?: string;
  /** Workflow run ID */
  run_id: string;
}
